"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveViewPlayer = void 0;
var _styles = require("@material-ui/core/styles");
var _pittaDesignSystem = require("@thingsw/pitta-design-system");
var _clsx11 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _Refresh = _interopRequireDefault(require("@material-ui/icons/Refresh"));
var _VolumeUp = _interopRequireDefault(require("@material-ui/icons/VolumeUp"));
var _VolumeOff = _interopRequireDefault(require("@material-ui/icons/VolumeOff"));
var _Flip = _interopRequireDefault(require("@material-ui/icons/Flip"));
var _Fullscreen = _interopRequireDefault(require("@material-ui/icons/Fullscreen"));
var _FullscreenExit = _interopRequireDefault(require("@material-ui/icons/FullscreenExit"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _AddCircleOutline = _interopRequireDefault(require("@material-ui/icons/AddCircleOutline"));
var _screenfull = _interopRequireDefault(require("screenfull"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireWildcard(require("lodash"));
var KVSWebRTC = _interopRequireWildcard(require("amazon-kinesis-video-streams-webrtc"));
var _reactRouterDom = require("react-router-dom");
var _hls = _interopRequireDefault(require("hls.js"));
var _detectBrowser = require("detect-browser");
var _pittaModules = require("@thingsw/pitta-modules");
var _withStyleProvider = require("../hoc/withStyleProvider");
var _moment = _interopRequireDefault(require("moment"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import { AnyAction, Dispatch } from "redux";

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      position: 'relative'
    },
    fullscreenRoot: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      zIndex: 9999,
      backgroundColor: 'black'
    },
    videoDiv: {
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
      paddingTop: 'min(56.25%, 720px, (100vh - 99px))',
      backgroundColor: 'black'
      // paddingTop:
      //   "max(350px, calc(100vh - 108px - 188px - 24px - 24px - 49px - 16px))",
    },
    mapboxVideoDiv: {
      width: '100%',
      position: 'relative',
      overflow: 'visible',
      paddingTop: 'min(57.25%, 720px)',
      backgroundColor: 'black'
      // paddingTop:
      //   "max(350px, calc(100vh - 108px - 188px - 24px - 24px - 49px - 16px))",
    },
    videoDivApp: {
      paddingTop: 'min(56.25%, 720px)'
    },
    videoDivAppLandscape: {
      paddingTop: '80vh'
    },
    multiViewDiv: {
      // paddingTop: "220px",
      // paddingTop: "34vh",
      paddingTop: '56.25%'
    },
    videoInner: {
      width: 'min(100%, 1280px)',
      paddingTop: 'min(56.25%, 720px)'
    },
    video: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      // transform: "translateX(-50%)",
      // width: "fit-content",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: "".concat(_pittaModules.LightColors.primary['1'], "4D"),
      overflow: 'hidden'
    },
    twoWayAlert: {
      position: 'absolute',
      top: 8,
      right: 12
    },
    twoWayAlertMulti: {
      top: 58
    },
    addCameraDiv: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: _pittaModules.LightColors.primary['6'],
      border: "1px solid ".concat(_pittaModules.LightColors.primary['4']),
      zIndex: 2
    },
    addCameraBtn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: _pittaModules.LightColors.primary['7'],
      '-webkit-touch-callout': 'none' /* iOS Safari */,
      '-webkit-user-select': 'none' /* Safari */,
      '-khtml-user-select': 'none' /* Konqueror HTML */,
      '-moz-user-select': 'none' /* Old versions of Firefox */,
      '-ms-user-select': 'none' /* Internet Explorer/Edge */,
      'user-select': 'none',
      /* Non-prefixed version, currently
         supported by Chrome, Edge, Opera and Firefox */
      cursor: 'pointer',
      '&:hover': {
        color: _pittaModules.LightColors.primary['8']
      },
      '&:active': {
        color: _pittaModules.LightColors.primary['8']
      }
    },
    videoHFlip: {
      '-webkit-transform': 'scale(-1, 1)',
      transform: 'scale(-1, 1)'
    },
    videoVFlip: {
      '-webkit-transform': 'scale(1, -1)',
      transform: 'scale(1, -1)'
    },
    videoFlip: {
      '-webkit-transform': 'scale(-1, -1)',
      transform: 'scale(-1, -1)'
    },
    ctrlContDiv: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      left: 0,
      bottom: 0,
      right: 0,
      padding: theme.spacing(0, 1),
      zIndex: 1,
      // mantis - 11582, 하단 컨트롤러가 잘 보이지않아 background css 추가 (Leehj)
      background: 'rgba(19, 19, 28, 0.25)'
    },
    blackvueIcon: {
      width: 160,
      height: 29,
      fill: _pittaModules.LightColors.primary['0']
    },
    circularLoading: {
      color: _pittaModules.LightColors.primary['0']
    },
    overlayDiv: {
      // mantis - 11582, 하단 워터마크색깔 위,아래 동일하게 하기 위해 background css 제거 (Leehj)
      // background:
      //   "linear-gradient(180deg, rgba(19, 19, 28, 0) 66.22%, rgba(19, 19, 28, 0.75) 95.5%)",
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    ctrlDiv: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(1, 0)
    },
    ctrlIcon: {
      padding: 0,
      marginRight: theme.spacing(1),
      color: "".concat(_pittaModules.LightColors.primary['0'], "!important"),
      fill: "".concat(_pittaModules.LightColors.primary['0'], "!important"),
      '&>svg': {
        color: "".concat(_pittaModules.LightColors.primary['0'], "!important"),
        fill: "".concat(_pittaModules.LightColors.primary['0'], "!important")
      },
      '&.Mui-disabled': {
        color: "".concat(_pittaModules.LightColors.primary['0'], "40"),
        fill: "".concat(_pittaModules.LightColors.primary['0'], "40")
      }
    },
    volumeCtrlDiv: {
      width: 52,
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(1)
    },
    playerMenuDiv: {
      backgroundColor: _pittaModules.LightColors.primary['1'],
      color: _pittaModules.LightColors.primary['0'],
      boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)',
      '& svg': {
        color: _pittaModules.LightColors.primary['0'],
        fill: _pittaModules.LightColors.primary['0']
      }
    },
    webMenuDiv: {
      '&:hover': {
        backgroundColor: _pittaModules.LightColors.primary['2']
      }
    },
    mobileMemuItem: {
      padding: theme.spacing(1.5, 2)
    },
    mobileMenuItemDark: {
      padding: theme.spacing(1.5, 2),
      backgroundColor: 'black'
    },
    menuDiv: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 80,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: "".concat(_pittaModules.LightColors.primary['1'], "73"),
      color: _pittaModules.LightColors.primary['0'],
      padding: theme.spacing(1.125, 1),
      // "& svg": {
      //   fill: LightColors.primary["0"],
      // },
      textShadow: '0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)'
    },
    dirDiv: {
      display: 'flex',
      alignItems: 'center',
      // mantis - 8362, 다국어 번역시 ui겹침 수정
      // width: 62,
      cursor: 'pointer'
    },
    selectedOverlay: {
      border: "3px solid ".concat(_pittaModules.LightColors.secondary['17'])
    },
    videoFullScreen: {
      paddingTop: 'calc(var(--vh, 1vh) * 100)'
    },
    mobilePlayCtrlDiv: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: "".concat(_pittaModules.LightColors.primary['1'], "73")
    },
    mobilePlayCtrl: {
      display: 'flex',
      minWidth: 216,
      justifyContent: 'center',
      alignItems: 'center'
    },
    disabledCtrlIcon: {
      padding: 0,
      marginRight: theme.spacing(1),
      '&>svg': {
        color: "".concat(_pittaModules.LightColors.primary['0'], "40"),
        fill: "".concat(_pittaModules.LightColors.primary['0'], "40")
      },
      display: 'flex'
    },
    uncheckedMenu: {
      paddingLeft: 44
    },
    disabled: {
      color: "".concat(_pittaModules.LightColors.primary['0'], "40"),
      fill: "".concat(_pittaModules.LightColors.primary['0'], "40")
    },
    ctrlContDivFullscreenApp: {
      // 12723 이슈 수정으로 주석처리
      // paddingBottom: 60,
    },
    darkMobileMenu: {
      backgroundColor: 'black',
      color: _pittaModules.LightColors.primary['0']
    }
  };
});
var CustomSigner = /*#__PURE__*/function () {
  function CustomSigner(_url) {
    _classCallCheck(this, CustomSigner);
    // 클래스를 정의
    _defineProperty(this, "url", void 0);
    this.url = _url;
  }
  _createClass(CustomSigner, [{
    key: "getSignedURL",
    value: function () {
      var _getSignedURL = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_signalingEndpoint, _queryParams, _date) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.url);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getSignedURL(_x, _x2, _x3) {
        return _getSignedURL.apply(this, arguments);
      }
      return getSignedURL;
    }()
  }]);
  return CustomSigner;
}();
var LiveViewPlayer = (0, _withStyleProvider.withStyleProvider)(function (props) {
  var _clsx6, _clsx7;
  var direction = props.direction,
    camera = props.camera,
    main = props.main,
    multiView = props.multiView,
    disabled = props.disabled,
    menuAnchorRef = props.menuAnchorRef,
    selected = props.selected,
    isPublic = props.isPublic,
    onAddCamera = props.onAddCamera,
    onClose = props.onClose,
    onChannelChange = props.onChannelChange,
    enableMic = props.enableMic,
    micBtnDisabled = props.micBtnDisabled,
    twoWayInUse = props.twoWayInUse,
    app = props.app,
    landscape = props.landscape,
    onToggleMic = props.onToggleMic,
    onAudioLevelChanged = props.onAudioLevelChanged,
    onNoMicPerm = props.onNoMicPerm,
    onChangePlaying = props.onChangePlaying,
    onMenuOpen = props.onMenuOpen,
    loadingTwoWay = props.loadingTwoWay,
    _props$userState = props.userState,
    email = _props$userState.email,
    loginInfo = _props$userState.loginInfo,
    usageInfo = _props$userState.usageInfo,
    tokenType = _props$userState.tokenType,
    userProfile = _props$userState.userProfile,
    subscriptionInfo = props.paymentState.subscriptionInfo,
    _props$cameraState = props.cameraState,
    publicCams = _props$cameraState.publicCams,
    cameraList = _props$cameraState.cameraList,
    removePlayer = props.liveviewState.removePlayer,
    _props$themeState = props.themeState,
    exitFullscreen = _props$themeState.exitFullscreen,
    color = _props$themeState.color,
    colors = _props$themeState.colors,
    onFinishLiveview = props.onFinishLiveview,
    onUpdateLiveviewUsage = props.onUpdateLiveviewUsage,
    onOpenToast = props.onOpenToast,
    onSetFullScreen = props.onSetFullScreen,
    onExitFullScreen = props.onExitFullScreen,
    onSetError = props.onSetError,
    t = props.t,
    mapboxModal = props.mapboxModal;
  var classes = useStyles(props);
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery["default"])(theme.breakpoints.down(_pittaModules.Webviewer.mobile));
  // mantis : 7394
  // Live view 연결 끊겼을 때, 모달 발생 & 페이지 이동을 위한 useHistory
  var history = (0, _reactRouterDom.useHistory)();
  var orientation = (0, _pittaModules.useScreenOrientation)();

  // const retryHlsConnectRef = useRef(false);
  var prevDirectionRef = (0, _react.useRef)(direction);
  var evCacheRef = (0, _react.useRef)([]);
  var prevDiffRef = (0, _react.useRef)(-1);
  var startCoordsRef = (0, _react.useRef)({});

  //remteView
  var remoteView = (0, _react.useRef)(null);
  var testView = (0, _react.useRef)(null);
  var fullScreenRef = (0, _react.useRef)(null);
  var videoRef = (0, _react.useRef)(null);
  var volumeAnchorRef = (0, _react.useRef)(null);
  var flipAnchorRef = (0, _react.useRef)(null);
  var disconnectedRef = (0, _react.useRef)(false);
  var stopLiveview = (0, _react.useRef)(false);
  var clientIDRef = (0, _react.useRef)(undefined);
  var audioAnimationRef = (0, _react.useRef)(null);
  var audioStreamRef = (0, _react.useRef)(null);
  var sendingSDPRef = (0, _react.useRef)(false);
  var receivedSDPRef = (0, _react.useRef)(false);
  var nTrySendSDPRef = (0, _react.useRef)(0);
  var retryTimer = (0, _react.useRef)();
  var sigClientPingRef = (0, _react.useRef)(null);
  var prevCamRef = (0, _react.useRef)(camera);
  // const refreshVideoRef = useRef<number | null>(null);

  var videoWaitingListenerRef = (0, _react.useRef)();
  var videoPlayingListenerRef = (0, _react.useRef)();
  var videoPlayListenerRef = (0, _react.useRef)();
  var videoPauseListenerRef = (0, _react.useRef)();
  var usedTimeRef = (0, _react.useRef)(0);
  var multiviewRef = (0, _react.useRef)(false);
  var lbServerNameRef = (0, _react.useRef)('');
  var _useState = (0, _react.useState)(1),
    _useState2 = _slicedToArray(_useState, 2),
    videoScale = _useState2[0],
    setVideoScale = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    videoMoveX = _useState4[0],
    setVideoMoveX = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    videoMoveY = _useState6[0],
    setVideoMoveY = _useState6[1];
  var _useState7 = (0, _react.useState)(direction),
    _useState8 = _slicedToArray(_useState7, 1),
    dir /*, setDir*/ = _useState8[0];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    openFlipMenu = _useState10[0],
    setOpenFlipMenu = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    openVolumeMenu = _useState12[0],
    setOpenVolumeMenu = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    hFlip = _useState14[0],
    setHFlip = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    vFlip = _useState16[0],
    setVFlip = _useState16[1];
  var _useState17 = (0, _react.useState)(true),
    _useState18 = _slicedToArray(_useState17, 2),
    loading = _useState18[0],
    setLoading = _useState18[1];
  // const [waiting, setWaiting] = useState<object | undefined>(undefined);
  // click 이벤트가 발생한 경우, default volume으로 아닌 경우 mute
  var _useState19 = (0, _react.useState)(0),
    _useState20 = _slicedToArray(_useState19, 2),
    volume = _useState20[0],
    setVolume = _useState20[1];
  var _useState21 = (0, _react.useState)(0),
    _useState22 = _slicedToArray(_useState21, 2),
    preVolume = _useState22[0],
    setPreVolume = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    fullscreen = _useState24[0],
    setFullscreen = _useState24[1];
  var _useState25 = (0, _react.useState)(false),
    _useState26 = _slicedToArray(_useState25, 1),
    refresh /*, setRefresh*/ = _useState26[0];
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    openMenu = _useState28[0],
    setOpenMenu = _useState28[1];
  var _useState29 = (0, _react.useState)(),
    _useState30 = _slicedToArray(_useState29, 2),
    hlsInst = _useState30[0],
    setHlsInst = _useState30[1];
  var _useState31 = (0, _react.useState)(false),
    _useState32 = _slicedToArray(_useState31, 2),
    openTooltip = _useState32[0],
    setOpenTooltip = _useState32[1];
  var _useState33 = (0, _react.useState)(false),
    _useState34 = _slicedToArray(_useState33, 2),
    disableVolume = _useState34[0],
    setDisableVolume = _useState34[1];
  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  var _useState35 = (0, _react.useState)(false),
    _useState36 = _slicedToArray(_useState35, 2),
    disableDir = _useState36[0],
    setDisableDir = _useState36[1];
  // CLOUD NATIVE 서버 에러 표시
  // const [serverError, setServerError] = useState(false);

  var _useState37 = (0, _react.useState)(false),
    _useState38 = _slicedToArray(_useState37, 2),
    playing = _useState38[0],
    setPlaying = _useState38[1];
  var _useState39 = (0, _react.useState)(true),
    _useState40 = _slicedToArray(_useState39, 2),
    muted = _useState40[0],
    setMuted = _useState40[1];
  // mantis : 7394
  // Live view 연결 끊겼을 때, 모달 open useState
  var _useState41 = (0, _react.useState)(false),
    _useState42 = _slicedToArray(_useState41, 2),
    liveModal = _useState42[0],
    setLiveModal = _useState42[1];
  var _useState43 = (0, _react.useState)('on'),
    _useState44 = _slicedToArray(_useState43, 2),
    camStatus = _useState44[0],
    setCamStatus = _useState44[1];
  var _useState45 = (0, _react.useState)(),
    _useState46 = _slicedToArray(_useState45, 2),
    firmwareConfig = _useState46[0],
    setFirmwareConfig = _useState46[1];
  var _useState47 = (0, _react.useState)(0),
    _useState48 = _slicedToArray(_useState47, 2),
    audioLevel = _useState48[0],
    setAudioLevel = _useState48[1];
  var _useState49 = (0, _react.useState)(false),
    _useState50 = _slicedToArray(_useState49, 2),
    directionChangeFailed = _useState50[0],
    setDirectionChangeFailed = _useState50[1];
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    openMuteTooltip = _React$useState2[0],
    setOpenMuteTooltip = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    openUnMuteTooltip = _React$useState4[0],
    setOpenUnMuteTooltip = _React$useState4[1];
  var _useState51 = (0, _react.useState)(false),
    _useState52 = _slicedToArray(_useState51, 1),
    autoPlayable /*, setAutoPlayable*/ = _useState52[0];
  var _useState53 = (0, _react.useState)(false),
    _useState54 = _slicedToArray(_useState53, 2),
    openUnplugged = _useState54[0],
    setOpenUnplugged = _useState54[1];
  var _useState55 = (0, _react.useState)(),
    _useState56 = _slicedToArray(_useState55, 2),
    presignedUrl = _useState56[0],
    setPresignedUrl = _useState56[1];
  var _useState57 = (0, _react.useState)(false),
    _useState58 = _slicedToArray(_useState57, 2),
    readyToConnect = _useState58[0],
    setReadyToConnect = _useState58[1];

  // mantis- 11582, 일정시간후에 하단메뉴바가 자동으로 사라지도록 하기위한 state (Leehj)
  var _useState59 = (0, _react.useState)(false),
    _useState60 = _slicedToArray(_useState59, 2),
    hideCtrl = _useState60[0],
    setHideCtrl = _useState60[1];
  var _useState61 = (0, _react.useState)(false),
    _useState62 = _slicedToArray(_useState61, 2),
    forceViewCtrl = _useState62[0],
    setForceViewCtrl = _useState62[1];
  var _useState63 = (0, _react.useState)(false),
    _useState64 = _slicedToArray(_useState63, 2),
    failToConnect = _useState64[0],
    setFailToConnect = _useState64[1];
  var _useState65 = (0, _react.useState)(false),
    _useState66 = _slicedToArray(_useState65, 2),
    retryConnect = _useState66[0],
    setRetryConnect = _useState66[1];
  var _useState67 = (0, _react.useState)({}),
    _useState68 = _slicedToArray(_useState67, 2),
    retryConnect2 = _useState68[0],
    setRetryConnect2 = _useState68[1];
  var dr750x3chplus = (0, _react.useMemo)(function () {
    return (camera === null || camera === void 0 ? void 0 : camera.model) === 'DR750X-3CH Plus';
  }, [camera === null || camera === void 0 ? void 0 : camera.model]);
  var HD_LIVEVIEW = (0, _react.useMemo)(function () {
    if (firmwareConfig === undefined) {
      return undefined;
    }
    return !!(firmwareConfig !== null && firmwareConfig !== void 0 && firmwareConfig.HDLiveview);
  }, [firmwareConfig]);
  var ios17Browser = (0, _react.useMemo)(function () {
    var _browser$version;
    var browser = (0, _detectBrowser.detect)();
    var version = (_browser$version = browser === null || browser === void 0 ? void 0 : browser.version) !== null && _browser$version !== void 0 ? _browser$version : '';

    // 13871 - ios 17에서 전부 발생하는 것 같아 조건 수정
    var ios17 = version.indexOf('17') > -1;
    return ((browser === null || browser === void 0 ? void 0 : browser.name) === 'ios' || (browser === null || browser === void 0 ? void 0 : browser.name) === 'ios-webview') && ios17;
  }, []);
  var remoteTransform = (0, _react.useMemo)(function () {
    if (ios17Browser && fullscreen) {
      if (HD_LIVEVIEW) {
        return 'scale(2,2)';
      }
      if (fullscreen) {
        return 'scale(2,1.666)';
      }

      //DR750X-3CH Plus 모델은 라이브뷰 영상 비율(640x480)이 다른 대시캠과 달라서 예외처리
      if (dr750x3chplus) {
        return 'scale(2.65,2)';
      }
      return 'scale(2.4,2)';
    }
    if (HD_LIVEVIEW) {
      return 'scale(1,1)';
    }
    if (fullscreen) {
      return 'scale(1,0.833)';
    }

    //DR750X-3CH Plus 모델은 라이브뷰 영상 비율(640x480)이 다른 대시캠과 달라서 예외처리
    if (dr750x3chplus) {
      return 'scale(1.325,1)';
    }
    return 'scale(1.2,1)';
  }, [ios17Browser, HD_LIVEVIEW, dr750x3chplus, fullscreen]);
  (0, _react.useEffect)(function () {
    multiviewRef.current = !!multiView;
  }, [multiView]);

  // mantis- 11582, 일정시간후에 하단메뉴바가 자동으로 사라지도록 하기위함. (Leehj)
  (0, _react.useEffect)(function () {
    if (!loading) {
      // 웹에서 FlipMenu 오픈시 컨트롤바 사라지는 이슈수정(Leehj)
      if (!hideCtrl && !forceViewCtrl) {
        var timerId = setTimeout(function () {
          return setHideCtrl(true);
        }, 2000);
        return function () {
          clearTimeout(timerId);
        };
      }
    } else {
      setHideCtrl(false);
    }
  }, [loading, hideCtrl, forceViewCtrl]);
  (0, _react.useEffect)(function () {
    if (!openFlipMenu) {
      setForceViewCtrl(false);
    }
  }, [openFlipMenu]);

  // useEffect(() => {
  //   const browser = detect();
  //   console.log("CloudNative1", "browser", browser);
  //   if (
  //     app ||
  //     browser?.name === "ios" ||
  //     (browser?.name === "chrome" && browser?.os === "Android OS")
  //   ) {
  //     setAutoPlayable(false);
  //   } else {
  //     canAutoPlay.audio({ timeout: 10000 }).then(({ result, error }) => {
  //       console.log("CloudNative1", "audio", "canAutoPlay", result, error);
  //       setAutoPlayable(result);
  //     });
  //   }
  // }, [app]);

  (0, _react.useEffect)(function () {
    console.log('LiveViewPlayer', 'playing', playing);
    onChangePlaying === null || onChangePlaying === void 0 ? void 0 : onChangePlaying(playing);
  }, [onChangePlaying, playing]);

  // mantis - 9178, 웹 제외. 모든 툴팁 최초 진입시에만 노출(Leehj).
  (0, _react.useEffect)(function () {
    if (app || mobile) {
      setOpenMuteTooltip(true);
      setTimeout(function () {
        return setOpenMuteTooltip(false);
      }, 3000);
      setOpenUnMuteTooltip(true);
      setTimeout(function () {
        return setOpenUnMuteTooltip(false);
      }, 3000);
    }
  }, [app, mobile]);
  var iosBrowser = (0, _react.useMemo)(function () {
    var browser = (0, _detectBrowser.detect)();
    return (browser === null || browser === void 0 ? void 0 : browser.name) === 'ios' || (browser === null || browser === void 0 ? void 0 : browser.name) === 'crios';
  }, []);
  var browserName = (0, _react.useMemo)(function () {
    var _detect;
    return (_detect = (0, _detectBrowser.detect)()) === null || _detect === void 0 ? void 0 : _detect.name;
  }, []);
  (0, _react.useEffect)(function () {
    if (!removePlayer) {
      disconnectedRef.current = false;
    }
  }, [removePlayer]);
  (0, _react.useEffect)(function () {
    if (directionChangeFailed) {
      var timer = setTimeout(function () {
        setDirectionChangeFailed(false);
      }, 2000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [directionChangeFailed]);
  (0, _react.useEffect)(function () {
    onAudioLevelChanged === null || onAudioLevelChanged === void 0 ? void 0 : onAudioLevelChanged(audioLevel);
  }, [audioLevel, onAudioLevelChanged]);
  (0, _react.useEffect)(function () {
    if (!enableMic) {
      if (audioAnimationRef.current) {
        clearInterval(audioAnimationRef.current);
      }
      setAudioLevel(0);
    } else {
      setMuted(false);
      if (mobile) {
        setVolume(100);
      } else {
        setVolume(50);
      }
    }
  }, [enableMic, mobile]);
  (0, _react.useEffect)(function () {
    return function () {
      setAudioLevel(0);
      if (audioAnimationRef.current) {
        // console.log("CloudNative1", "cancelAnimationFrame");
        clearInterval(audioAnimationRef.current);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (_lodash["default"].isEqual(camera, prevCamRef.current) && firmwareConfig) return;
    if (camera) {
      var config = (0, _pittaModules.getFirmwareConfig)(camera);
      // console.log(
      //   "CloudNative1",
      //   "getFirmwareConfig",
      //   "camera",
      //   camera,
      //   "config",
      //   config
      // );
      setFirmwareConfig(config);
      prevCamRef.current = camera;
    }
  }, [camera, firmwareConfig]);
  (0, _react.useEffect)(function () {
    if (camStatus === 'off') {
      var _remoteView$current;
      if (app) {
        //10670 - 앱에서는 앱이 모달 표시하도록 수정 (mckim)
        onFinishLiveview('DEVICE_DISCONNECT');
      } else {
        // mantis : 7394
        // Live view 연결 끊겼을 때, 모달 open
        setLiveModal(true);
      }
      console.log('LiveViewPlayer', 'set loading to false', 'cam off');
      setLoading(false);
      (_remoteView$current = remoteView.current) === null || _remoteView$current === void 0 ? void 0 : _remoteView$current.pause();
    }
  }, [app, camStatus]);
  (0, _react.useEffect)(function () {
    if (isPublic) {
      var found = _lodash["default"].find(publicCams, function (dev) {
        return dev.psn === (camera === null || camera === void 0 ? void 0 : camera.psn);
      });
      if ((found === null || found === void 0 ? void 0 : found.active) === 'off') {
        // mantis : 7394
        // Live view 연결 끊겼을 때, 현재 연결 상태를 off로 변경
        setCamStatus('off');
      }
    }
  }, [camera === null || camera === void 0 ? void 0 : camera.psn, isPublic, publicCams]);

  //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
  var isOptionModel = (0, _react.useMemo)(function () {
    return _lodash["default"].includes(_pittaModules.OPTION_CAMERA_MODELS, camera === null || camera === void 0 ? void 0 : camera.model);
  }, [camera === null || camera === void 0 ? void 0 : camera.model]);

  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  (0, _react.useEffect)(function () {
    if (disableDir) {
      var timerId = setTimeout(function () {
        setDisableDir(false);
      }, 5000);
      return function () {
        clearTimeout(timerId);
      };
    }
  }, [disableDir]);

  //webrtc 연결용
  var peerConnection = (0, _react.useRef)(null);
  var signalingClient = (0, _react.useRef)(null);
  var localView = (0, _react.useRef)(null);
  var localStream = (0, _react.useRef)(null);
  var remoteStream = (0, _react.useRef)(null);
  var usageInfoRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    usageInfoRef.current = usageInfo;
  }, [usageInfo]);
  var CLOUD_NATIVE = (0, _react.useMemo)(function () {
    // console.log("CloudNative1", "firmwareConfig", firmwareConfig);
    if (firmwareConfig === undefined) {
      return undefined;
    }
    return !!(firmwareConfig !== null && firmwareConfig !== void 0 && firmwareConfig.CloudNative);
  }, [firmwareConfig]);
  var resetConnection = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var cam, p, local;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (camera) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          cam = camera;
          p = remoteView.current;
          local = localView.current; // console.log(
          //   "CloudNative1",
          //   "clientID",
          //   clientIDRef.current,
          //   "start removing connection..."
          // );
          disconnectedRef.current = true;
          if (audioStreamRef.current) {
            // console.log(
            //   "CloudNative1",
            //   "clientID",
            //   clientIDRef.current,
            //   "sending TwoWayStop to",
            //   cam.psn
            // );
            audioStreamRef.current.getTracks().forEach(function (track) {
              return track.stop();
            });
            audioStreamRef.current = null;
            _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
              command: 'TwoWayStop',
              email: email,
              user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
              tokenType: tokenType,
              psn: cam.psn
            });
          }
          _context2.next = 9;
          return (0, _pittaModules.sleep)(1500);
        case 9:
          if (!sendingSDPRef.current) {
            // kvs 채널 연결이 정상적으로 되지 않은 경우를 대비해 Stop메시지 추가로 보냄 (20220714)
            // TwoWayStart한 경우는 라이브뷰 정상연결된 경우로 StopLiveView 안보냄
            // console.log(
            //   "CloudNative1",
            //   "clientID",
            //   clientIDRef.current,
            //   "sending StopLiveView1 to",
            //   cam.psn
            // );
            _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
              command: 'StopLiveView',
              email: email,
              user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
              tokenType: tokenType,
              psn: cam.psn
            });
          }

          // console.log(
          //   "CloudNative1",
          //   "clientID",
          //   clientIDRef.current,
          //   "removing webrtc...",
          //   cam.psn
          // );
          p === null || p === void 0 ? void 0 : p.pause();
          local === null || local === void 0 ? void 0 : local.pause();
          setHlsInst(undefined);
          setPresignedUrl(undefined);
          setReadyToConnect(false);

          // console.log(
          //   "CloudNative1",
          //   "clientID",
          //   clientIDRef.current,
          //   "close signaling client...",
          //   cam.psn,
          //   signalingClient.current
          // );
          // webrtc 정리
          if (signalingClient.current) {
            signalingClient.current.close();
            signalingClient.current = null;
          }
          if (peerConnection.current) {
            peerConnection.current.close();
            peerConnection.current = null;
          }
          if (localStream.current) {
            localStream.current.getTracks().forEach(function (track) {
              return track.stop();
            });
            localStream.current = null;
          }
          if (remoteStream.current) {
            remoteStream.current.getTracks().forEach(function (track) {
              return track.stop();
            });
            remoteStream.current = null;
          }
          if (local) {
            local.srcObject = null;
          }
          if (p) {
            p.srcObject = null;
          }

          // setLoading(true);
          setLoading(false);
          setRetryConnect(true);
          setReadyToConnect(false);
          disconnectedRef.current = false;
        case 25:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [CLOUD_NATIVE, camera, email, loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token, tokenType]);
  var exitAppFullscreen = (0, _react.useCallback)(function () {
    var _window$Webviewer;
    fullScreenRef.current.fullscreen = false;
    setFullscreen(fullScreenRef.current.fullscreen);
    // mantis - 10092, 카메라 방향 드롭박스가 open된 채로 전체화면을 나가면 전체화면이 아닐 때 출력되는 카메라 방향 드롭박스를 열어준다. (Leehj)
    if (openMenu && !multiView) {
      onMenuOpen === null || onMenuOpen === void 0 ? void 0 : onMenuOpen();
    }
    // mantis - 10092, 전체화면을 나가면 전체화면에서만 사용중인 카메라 방향 드롭박스를 닫아준다. (Leehj)
    if (!multiView) {
      setOpenMenu(false);
    }
    if (browserName === 'ios-webview' &&
    //@ts-ignore
    webkit.messageHandlers.disableRotate) {
      //@ts-ignore
      webkit.messageHandlers.disableRotate.postMessage({});
    }
    if (browserName === 'chromium-webview' && //@ts-ignore
    (_window$Webviewer = window.Webviewer) !== null && _window$Webviewer !== void 0 && _window$Webviewer.disableRotate) {
      var _window$Webviewer2, _window$Webviewer2$di;
      //@ts-ignore
      (_window$Webviewer2 = window.Webviewer) === null || _window$Webviewer2 === void 0 || (_window$Webviewer2$di = _window$Webviewer2.disableRotate) === null || _window$Webviewer2$di === void 0 ? void 0 : _window$Webviewer2$di.call(_window$Webviewer2);
    }
  }, [browserName, multiView, onMenuOpen, openMenu]);

  //@ts-ignore
  window.exitFullScreen = (0, _react.useCallback)(function () {
    // console.log(
    //   "CloudNative1",
    //   "LiveViewPlayer",
    //   "window.exitFullScreen",
    //   fullScreenRef.current
    // );
    if (fullScreenRef.current) {
      exitAppFullscreen();
    }
  }, [exitAppFullscreen]);

  // Free, lite 계정 & 라이브뷰 제한까지 사용하면 Loading = false
  (0, _react.useEffect)(function () {
    if (subscriptionInfo !== null && subscriptionInfo !== void 0 && subscriptionInfo.servicePlanName && ((subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName) === 'free' || (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName.indexOf('lite')) > -1)) {
      if (usageInfo && usageInfo.LimitLiveView !== 0 && usageInfo.liveViewDayUsage >= usageInfo.LimitLiveView) {
        console.log('LiveViewPlayer', 'set loading to false', 'usageInfo');
        setLoading(false);
      }
    }
  }, [subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName, usageInfo]);

  // mantis - 12419, Live view 소진한 상태면 버튼 비활성화 (Leehj)
  // mantis - 12439, Flip 버튼과 Fullscreen 버튼 비활성화 상태로 노출하는 현상 수정 (Leehj)
  var isLimitLiveView = (0, _react.useMemo)(function () {
    if (subscriptionInfo !== null && subscriptionInfo !== void 0 && subscriptionInfo.servicePlanName && (subscriptionInfo.servicePlanName === 'free' || subscriptionInfo.servicePlanName.indexOf('lite') > -1)) {
      if (usageInfo && usageInfo.LimitLiveView !== 0 && usageInfo.liveViewDayUsage >= usageInfo.LimitLiveView) {
        return true;
      }
    }
    return false;
  }, [subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName, usageInfo]);
  (0, _react.useEffect)(function () {
    if (camera && isPublic) {
      // 공유된 카메라의 share_audio가 on이 아니면 mute시키고 volume controller disable
      if (camera.share_audio !== 'on') {
        setVolume(0);
        setDisableVolume(true);
      }
    }
  }, [camera, isPublic]);
  (0, _react.useEffect)(function () {
    return function () {
      console.log('LiveViewPlayer', 'camera', camera, 'usedTimeRef.current', usedTimeRef.current);
      if (camera && usedTimeRef.current > 0) {
        onUpdateLiveviewUsage({
          psn: camera.psn,
          usage: Math.round(usedTimeRef.current)
        });
      }
    };
  }, [camera]);
  (0, _react.useEffect)(function () {
    if (browserName === 'ios-webview' || browserName === 'ios') {
      var checkPaused = function checkPaused() {
        var _remoteView$current2, _remoteView$current3;
        // if (clientWidth > clientHeight) {
        //   remoteView.current?.load();
        //   remoteView.current?.play();
        // }
        if (((_remoteView$current2 = remoteView.current) === null || _remoteView$current2 === void 0 ? void 0 : _remoteView$current2.paused) === false) {
          // ref.current?.play();
          // console.log("LiveViewPlayer", "set loading to false", "paused");
          // 이거때문에 ios에서 화면 나오기전에 loading창이 사라져서 주석처리
          // setLoading(false);
          // setPlaying(true);
        } else if (((_remoteView$current3 = remoteView.current) === null || _remoteView$current3 === void 0 ? void 0 : _remoteView$current3.paused) === true) {
          var _remoteView$current4;
          console.log('LiveViewPlayer', 'checkPaused', 'try to play');
          (_remoteView$current4 = remoteView.current) === null || _remoteView$current4 === void 0 ? void 0 : _remoteView$current4.play();
        }
      };
      var timer = setInterval(checkPaused, 500);
      return function () {
        clearInterval(timer);
      };
    }
  }, [browserName]);
  (0, _react.useEffect)(function () {
    var updateUsedTime = function updateUsedTime() {
      usedTimeRef.current = usedTimeRef.current + 0.2;
      console.log('LiveViewPlayer', 'updateUsedTime', 'usedTimeRef.current', usedTimeRef.current, 'usageInfo?.LimitLiveView', usageInfo === null || usageInfo === void 0 ? void 0 : usageInfo.LimitLiveView, 'camera');
      if (usageInfo && usageInfo.LimitLiveView > 0 && camera) {
        if (usageInfo.liveViewDayUsage + usedTimeRef.current >= usageInfo.LimitLiveView) {
          console.log('LiveViewPlayer', 'updateUsedTime', 'pause');
          // remoteView.current?.pause();
          hlsInst === null || hlsInst === void 0 ? void 0 : hlsInst.stopLoad();
          // hlsInst?.detachMedia();
          // setHlsInst(undefined);
          // setPlaying(false);
          console.log('LiveViewPlayer', 'set loading to false', 'updateUsedTime');
          // setLoading(false);
          if (usedTimeRef.current > 0) {
            onUpdateLiveviewUsage({
              psn: camera.psn,
              usage: Math.round(usedTimeRef.current)
            });
          }
          usedTimeRef.current = 0;
        }
      }
    };
    console.log('LiveViewPlayer', 'playing', playing, 'usageInfo', usageInfo);
    if (playing && usageInfo) {
      if (usageInfo.liveViewDayUsage < usageInfo.LimitLiveView) {
        var timer = setInterval(updateUsedTime, 200);
        return function () {
          clearInterval(timer);
        };
      }
    }
  }, [camera, hlsInst, playing, usageInfo]);
  (0, _react.useEffect)(function () {
    var changeDirection = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(cam, cdir) {
        var resp, data, _resp$data, _prevDirectionRef$cur, server_name, _err$response, _prevDirectionRef$cur2;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (direction) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              if (!CLOUD_NATIVE) {
                _context3.next = 10;
                break;
              }
              _context3.next = 5;
              return _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
                command: 'LiveDirection',
                email: email,
                user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
                tokenType: tokenType,
                psn: camera === null || camera === void 0 ? void 0 : camera.psn,
                param1: "".concat(cdir)
              });
            case 5:
              resp = _context3.sent;
              if (typeof resp.data === 'string') {
                data = JSON.parse((_resp$data = resp.data) !== null && _resp$data !== void 0 ? _resp$data : '{}');
              } else {
                data = resp.data;
              }
              // console.log("CloudNative1", "changeDirection", data);

              if (data.resultcode === 'BC_ERR_OK') {
                if (data.status === 'busy') {
                  prevDirectionRef.current = parseInt(data.direction);
                  onChannelChange(prevDirectionRef.current, true);
                  onOpenToast({
                    message: 'Please try again later.'
                  });
                } else {
                  prevDirectionRef.current = cdir;
                }
              } else if (data.resultcode === 'BC_ERR_UNPLUGED') {
                //  mantis - 9266, 전체화면시에도 토스트팝업 노출되도록 수정(Leehj)
                if (fullscreen) {
                  setOpenUnplugged(true);
                } else {
                  onOpenToast({
                    message: 'Camera is unplugged'
                  });
                }
                onChannelChange((_prevDirectionRef$cur = prevDirectionRef.current) !== null && _prevDirectionRef$cur !== void 0 ? _prevDirectionRef$cur : 1, true);
                setDisableDir(false);
              } else if (data.resultcode === 'BC_ERR_TIMEOUT') {
                // console.log("CloudNative1", "device command", "Request Timeout");
                onSetError('Request Timeout');
              }
              _context3.next = 23;
              break;
            case 10:
              server_name = (0, _pittaModules.getLbURI)(cam.lb_server_name, cam.lb_http_port);
              _context3.prev = 11;
              _context3.next = 14;
              return _axios["default"].get("".concat(server_name, "/proc/live_direction?email=").concat(email, "&user_token=").concat(loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token, "&psn=").concat(cam.psn, "&direction=").concat(cdir, "&tokenType=").concat(tokenType));
            case 14:
              prevDirectionRef.current = direction;
              onChannelChange(direction);
              _context3.next = 23;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](11);
              if (((_err$response = _context3.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 421) {
                onOpenToast({
                  message: 'Camera is unplugged'
                });
              } else {
                onOpenToast({
                  message: 'Please check the connection_'
                });
              }
              onChannelChange((_prevDirectionRef$cur2 = prevDirectionRef.current) !== null && _prevDirectionRef$cur2 !== void 0 ? _prevDirectionRef$cur2 : 1, true);
              setDisableDir(false);
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[11, 18]]);
      }));
      return function changeDirection(_x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }();
    // console.log(
    //   "CloudNative1",
    //   CLOUD_NATIVE,
    //   "changing direction is requested",
    //   "direction",
    //   direction,
    //   "prevDirectionRef.current",
    //   prevDirectionRef.current
    // );
    if (camera && prevDirectionRef.current !== direction) {
      changeDirection(camera, direction !== null && direction !== void 0 ? direction : 1);
    }
  }, [CLOUD_NATIVE, camera, direction, email, fullscreen, loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token, onChannelChange, tokenType]);
  (0, _react.useEffect)(function () {
    function exitHandler(evt) {
      var fullscreenElement =
      //@ts-ignore
      document.fullscreenElement || document.webkitCurrentFullScreenElement;
      // console.log(
      //   "CloudNative1",
      //   "LiveViewPlayer",
      //   "exitHandler",
      //   evt,
      //   fullScreenRef.current.fullscreen,
      //   fullscreenElement
      // );
      if (fullScreenRef.current && !fullscreenElement) {
        exitAppFullscreen();
      }
      setOpenTooltip(false);
    }
    if (_screenfull["default"].isEnabled) {
      _screenfull["default"].on('change', exitHandler);
      return function () {
        //@ts-ignore
        _screenfull["default"].off('change', exitHandler);
      };
    }
  }, [browserName, exitAppFullscreen]);
  var handleChangeChannel = (0, _react.useCallback)(function (dir) {
    // console.log("CloudNative1", "handleChangeChannel", dir);
    // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
    if (dir !== direction) {
      setDisableDir(true);
    }
    setOpenMenu(false);
    onChannelChange(dir);
  }, [direction, onChannelChange]);
  var directionMenuMarkup = (0, _react.useMemo)(function () {
    if (camera) {
      var _clsx3, _clsx4;
      var _dir = direction !== null && direction !== void 0 ? direction : 1;
      //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
      var direction3rd = undefined;
      if (_lodash["default"].includes(_pittaModules.MODELS_3CH, camera.model)) {
        if (isOptionModel) {
          var _clsx;
          direction3rd = /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
            key: "direction-option",
            startIcon: !mobile && _dir === _pittaModules.Option && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
              fontSize: "small",
              htmlColor: colors.primary['1']
            }),
            endIcon: mobile && _dir === _pittaModules.Option && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
              fontSize: "small",
              htmlColor: colors.primary['1']
            }),
            className: (0, _clsx11["default"])((_clsx = {}, _defineProperty(_clsx, classes.uncheckedMenu, _dir !== _pittaModules.Option && !mobile), _defineProperty(_clsx, classes.mobileMemuItem, mobile), _clsx)),
            onClick: function onClick() {
              handleChangeChannel(_pittaModules.Option);
            }
          }, t('Option'));
        } else {
          var _clsx2;
          direction3rd = /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
            key: "direction-interior",
            startIcon: !mobile && _dir === _pittaModules.Interior && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
              fontSize: "small",
              htmlColor: colors.primary['1']
            }),
            endIcon: mobile && _dir === _pittaModules.Interior && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
              fontSize: "small",
              htmlColor: colors.primary['1']
            }),
            className: (0, _clsx11["default"])((_clsx2 = {}, _defineProperty(_clsx2, classes.uncheckedMenu, direction !== _pittaModules.Interior && !mobile), _defineProperty(_clsx2, classes.mobileMemuItem, mobile), _clsx2)),
            onClick: function onClick() {
              handleChangeChannel(_pittaModules.Interior);
            }
          }, t('Interior'));
        }
      }
      return _lodash["default"].compact([/*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
        key: "direction-front",
        startIcon: !mobile && _dir === _pittaModules.Front && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          fontSize: "small",
          htmlColor: colors.primary['1']
        }),
        endIcon: mobile && _dir === _pittaModules.Front && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          fontSize: "small",
          htmlColor: colors.primary['1']
        }),
        className: (0, _clsx11["default"])((_clsx3 = {}, _defineProperty(_clsx3, classes.uncheckedMenu, _dir !== _pittaModules.Front && !mobile), _defineProperty(_clsx3, classes.mobileMemuItem, mobile), _clsx3)),
        onClick: function onClick() {
          handleChangeChannel(_pittaModules.Front);
        }
      }, t('Front')), _lodash["default"].includes([].concat(_toConsumableArray(_pittaModules.MODELS_2CH), _toConsumableArray(_pittaModules.MODELS_3CH)), camera.model) && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
        key: "direction-rear",
        startIcon: !mobile && _dir === _pittaModules.Rear && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          fontSize: "small",
          htmlColor: colors.primary['1']
        }),
        endIcon: mobile && _dir === _pittaModules.Rear && /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          fontSize: "small",
          htmlColor: colors.primary['1']
        }),
        className: (0, _clsx11["default"])((_clsx4 = {}, _defineProperty(_clsx4, classes.uncheckedMenu, _dir !== _pittaModules.Rear && !mobile), _defineProperty(_clsx4, classes.mobileMemuItem, mobile), _clsx4)),
        onClick: function onClick() {
          handleChangeChannel(_pittaModules.Rear);
        }
      }, t('Rear')), direction3rd]);
    }
  }, [camera, classes.mobileMemuItem, classes.uncheckedMenu, direction, handleChangeChannel, isOptionModel, mobile, t]);
  var handleFullscreen = (0, _react.useCallback)(function () {
    console.log('LiveViewPlayer', 'handleFullscreen', fullscreen, (0, _detectBrowser.detect)());
    // alert(JSON.stringify(detect()));
    setVideoScale(1);
    setVideoMoveX(0);
    setVideoMoveY(0);
    if (iosBrowser) {
      setFullscreen(function (f) {
        return !f;
      });
    } else if (fullScreenRef.current) {
      if (fullscreen) {
        (0, _pittaModules.exitFullscreen)(fullScreenRef.current);
        fullScreenRef.current.fullscreen = false;
        onSetFullScreen(false);
        setFullscreen(false);
      } else {
        (0, _pittaModules.requestFullscreen)(fullScreenRef.current);
        fullScreenRef.current.fullscreen = true;
        onSetFullScreen(true);
        setFullscreen(true);
      }
      // toggleFullscreen(fullScreenRef.current);
      // onSetFullScreen(fullScreenRef.current.fullscreen);
      // console.log(
      //   "CloudNative1",
      //   "LiveViewPlayer",
      //   "handleFullscreen",
      //   fullScreenRef.current.fullscreen
      // );
      if (app) {
        if (fullScreenRef.current.fullscreen) {
          (0, _pittaModules.changeLandscape)();
        } else {
          (0, _pittaModules.changePortrait)();
        }
      }
      // setFullscreen(fullScreenRef.current.fullscreen);
      setOpenTooltip(false);
    }
  }, [app, browserName, iosBrowser, fullscreen]);

  // useEffect(() => {
  //   const browser = detect()?.name;
  //   if (browser !== "ios-webview") return;
  //   if (remoteView.current) {
  //     const updateRemoveView = () => {
  //       if (!remoteView.current) return;
  //       console.log("LiveViewPlayer", "updateRemoteView");
  //       remoteView.current.style.display = "none";
  //       remoteView.current.offsetHeight;
  //       remoteView.current.style.display = "block";
  //     };
  //     // ResizeObserver 설정
  //     let timeout1: NodeJS.Timeout | null = null;
  //     let timeout2: NodeJS.Timeout | null = null;
  //     let timeout3: NodeJS.Timeout | null = null;
  //     const resizeObserver = new ResizeObserver(() => {
  //       console.log("LiveViewPlayer", "resizeObserver");
  //       // timeout1 = setTimeout(updateRemoveView, 100);
  //       // timeout3 = setTimeout(updateRemoveView, 300);
  //     });

  //     resizeObserver.observe(remoteView.current);
  //     return () => {
  //       if (timeout1) {
  //         clearTimeout(timeout1);
  //       }
  //       if (timeout2) {
  //         clearTimeout(timeout2);
  //       }
  //       if (timeout3) {
  //         clearTimeout(timeout3);
  //       }
  //       resizeObserver.disconnect();
  //     };
  //   }
  // }, [fullscreen]);

  (0, _react.useEffect)(function () {
    if (app) {
      var needToFullscreen = orientation.startsWith('landscape');
      console.log('LiveViewPlayer', 'orientation', orientation, needToFullscreen);
      if (fullScreenRef.current) {
        var _fullScreenRef$curren;
        if (needToFullscreen && !((_fullScreenRef$curren = fullScreenRef.current) !== null && _fullScreenRef$curren !== void 0 && _fullScreenRef$curren.fullscreen)) {
          (0, _pittaModules.requestFullscreen)(fullScreenRef.current);
          fullScreenRef.current.fullscreen = true;
          onSetFullScreen(true);
          setFullscreen(true);
        } else if (!needToFullscreen) {
          (0, _pittaModules.exitFullscreen)(fullScreenRef.current);
          fullScreenRef.current.fullscreen = false;
          onSetFullScreen(false);
          setFullscreen(false);
        }
        setOpenTooltip(false);
      }
      var updateRemoveView = function updateRemoveView() {
        var _testView$current;
        if (!remoteView.current) return;
        // console.log("LiveViewPlayer", "updateRemoteView");
        // remoteView.current.style.display = "none";
        // remoteView.current.offsetHeight;
        // remoteView.current.style.display = "block";
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var element = remoteView.current;
        canvas.width = element.clientWidth;
        canvas.height = element.clientHeight;
        ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(element, 0, 0, canvas.width, canvas.height);
        (_testView$current = testView.current) === null || _testView$current === void 0 ? void 0 : _testView$current.appendChild(canvas);

        // 비디오 요소에 캔버스를 다시 그립니다.
        // element.srcObject = canvas.captureStream().getVideoTracks()[0];
        element.load();
        element.play();

        // 강제로 비디오를 다시 그리기
        setTimeout(function () {
          var _testView$current2;
          (_testView$current2 = testView.current) === null || _testView$current2 === void 0 ? void 0 : _testView$current2.removeChild(canvas);
        }, 100);
      };
      setTimeout(updateRemoveView, 100);
    }
  }, [app, browserName, orientation]);
  (0, _react.useEffect)(function () {
    if (exitFullscreen) {
      if (iosBrowser) {
        setFullscreen(false);
      } else {
        if (fullScreenRef !== null && fullScreenRef !== void 0 && fullScreenRef.current.fullscreen) {
          handleFullscreen();
        }
      }
      onExitFullScreen(undefined);
    }
  }, [exitFullscreen, handleFullscreen, iosBrowser]);
  (0, _react.useEffect)(function () {
    if (remoteView.current) {
      if (multiviewRef.current) {
        if (selected) {
          remoteView.current.volume = volume / 100;
          if (volume !== 0) {
            setMuted(false);
          }
        } else {
          remoteView.current.volume = 0;
          setMuted(true);
        }
      } else {
        remoteView.current.volume = volume / 100;
      }
    }
    // console.log(
    //   "CloudNative1",
    //   "clicked",
    //   selected,
    //   volume,
    //   remoteView.current?.volume
    // );
  }, [selected, volume]);
  (0, _react.useEffect)(function () {
    if (multiviewRef.current) {
      if (selected) {
        setVolume(50);
      } else {
        setVolume(0);
      }
      setPreVolume(50);
    }
  }, [selected]);
  (0, _react.useEffect)(function () {
    var _$find, _lbInfoCam$lb_server_, _lbInfoCam$lb_http_po;
    var lbInfoCam = (_$find = _lodash["default"].find(cameraList === null || cameraList === void 0 ? void 0 : cameraList.deviceListInfo, function (dev) {
      return dev.device.psn === (camera === null || camera === void 0 ? void 0 : camera.psn);
    })) === null || _$find === void 0 ? void 0 : _$find.device;

    // lbServerNameRef.current = camera
    //   ? getLbURI(
    //       lbInfoCam?.lb_server_name ?? camera.lb_server_name,
    //       lbInfoCam?.lb_http_port ?? camera.lb_http_port
    //     )
    //   : "";
    lbServerNameRef.current = camera ? "https://".concat((_lbInfoCam$lb_server_ = lbInfoCam === null || lbInfoCam === void 0 ? void 0 : lbInfoCam.lb_server_name) !== null && _lbInfoCam$lb_server_ !== void 0 ? _lbInfoCam$lb_server_ : camera.lb_server_name, ":").concat((_lbInfoCam$lb_http_po = lbInfoCam === null || lbInfoCam === void 0 ? void 0 : lbInfoCam.lb_http_port) !== null && _lbInfoCam$lb_http_po !== void 0 ? _lbInfoCam$lb_http_po : camera.lb_http_port) : '';
  }, [camera, cameraList]);

  // useEffect(() => {
  //   if (camera && hlsInst && (loading || waiting)) {
  //     const psn = camera.psn;
  //     const time = moment().toString();
  //     // console.log(psn, time, "start restart timeout", waiting, loading);
  //     const timeout = setTimeout(() => {
  //       console.log(psn, time, "restart hls liveview");
  //       // hlsInst?.destroy();
  //       // setHlsInst(undefined);
  //       setLoading(false);
  //       setWaiting(undefined);
  //       setRetryConnect(true);
  //     }, 30 * 1000);
  //     return () => {
  //       // console.log(psn, time, "clear restart timeout");
  //       clearTimeout(timeout);
  //     };
  //   }
  // }, [loading, waiting, camera, hlsInst]);

  (0, _react.useEffect)(function () {
    if (camera && hlsInst && !failToConnect) {
      var psn = camera.psn;
      var time = (0, _moment["default"])().toString();
      var interval = setInterval(function () {
        console.log(psn, time, 'hlsEvent', 'scheduled restart hls liveview');
        setLoading(false);
        // setWaiting(undefined);
        setRetryConnect(true);
      }, 10 * 60 * 1000);
      return function () {
        clearInterval(interval);
      };
    }
  }, [camera, hlsInst]);
  var startPlay = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var videoSrc, video, hls, match;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          console.log('startPlay', 'camera', camera, 'lbServerName', lbServerNameRef.current);
          if (camera && lbServerNameRef.current && remoteView.current && email && loginInfo && !disabled) {
            //카메라 서버 이름 바뀌는게 적용 안됨...
            videoSrc = "".concat(lbServerNameRef.current, "/proc/hls_live.m3u8?email=").concat(email, "&user_token=").concat(loginInfo.user_token, "&tokenType=").concat(tokenType, "&psn=").concat(camera.psn, "&direction=").concat(dir !== null && dir !== void 0 ? dir : 1);
            video = remoteView.current;
            if (dir === undefined) {
              prevDirectionRef.current = 1;
              onChannelChange(1);
            }
            if (_hls["default"].isSupported()) {
              hls = new _hls["default"]({
                // debug: true,
                enableWorker: true,
                // lowLatencyMode: true,
                liveDurationInfinity: true,
                liveSyncDuration: 20,
                // liveSyncDurationCount: 10,
                backBufferLength: 90,
                highBufferWatchdogPeriod: 20,
                forceKeyFrameOnDiscontinuity: true,
                maxBufferLength: 10,
                maxBufferHole: 3,
                fragLoadPolicy: {
                  "default": {
                    maxTimeToFirstByteMs: 10000,
                    maxLoadTimeMs: 120000,
                    timeoutRetry: {
                      maxNumRetry: 0,
                      retryDelayMs: 1000,
                      maxRetryDelayMs: 8000
                    },
                    errorRetry: {
                      maxNumRetry: 0,
                      retryDelayMs: 1000,
                      maxRetryDelayMs: 8000,
                      backoff: 'exponential'
                    }
                  }
                }
              });
              setHlsInst(hls);
              hls.loadSource(videoSrc);
              hls.attachMedia(video);
              hls.on(_hls["default"].Events.MANIFEST_PARSED, function () {
                var now = (0, _moment["default"])().toString();
                console.log(camera.psn, now, 'hlsEvent', 'MANIFEST_PARSED');
                video.play()["catch"](function (e) {
                  console.log(camera.psn, now, 'hlsEvent', 'MANIFEST_PARSED', 'error', e);
                });
                setRetryConnect(false);
              });
              // hls.on(Hls.Events.FRAG_PARSED, function (data) {
              //   const now = moment().toString();
              //   console.log(camera.psn, now, "hlsEvent", "FRAG_PARSED", data);
              //   // 정상적으로 fragment parsing할때마다 재시도 타이머 리셋
              //   setWaiting({});
              // });
              hls.on(_hls["default"].Events.ERROR, function (err, data) {
                var now = (0, _moment["default"])().toString();
                console.log(camera.psn, now, 'hlsEvent', 'error', err, data);
                if (_lodash["default"].includes(['fragLoadError'], data.details)) {
                  setLoading(true);
                  setTimeout(function () {
                    hls.startLoad();
                  }, 2000);
                }
                if (_lodash["default"].includes(['levelLoadError', 'bufferAppendError', 'bufferNudgeOnStall'], data.details)) {
                  // hls.destroy();
                  // setHlsInst(undefined);
                  setLoading(false);
                  setRetryConnect(true);
                }
                if (_lodash["default"].includes(['manifestLoadError'], data.details)) {
                  if (retryConnect) {
                    // retryPlay();
                    setRetryConnect2({});
                  } else {
                    setLoading(false);
                    onSetError('An error occurred_again');
                  }
                }

                // if (_.includes(["bufferAppendError"], data.details)) {
                //   hls.detachMedia();
                //   hls.attachMedia(video);
                // }

                // dispatch(setError("An error occurred_again"));
              });
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
              console.log('video can play type...');
              match = /\/hls\/[\w-]{5,}\/\d+.ts/g;
              try {
                _lodash["default"].reduce(_lodash["default"].range(0, 20), /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(prevPromise, indx) {
                    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;
                          _context5.next = 3;
                          return prevPromise;
                        case 3:
                          return _context5.abrupt("return", new Promise(/*#__PURE__*/function () {
                            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
                              var resp, matched;
                              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                while (1) switch (_context4.prev = _context4.next) {
                                  case 0:
                                    _context4.next = 2;
                                    return _axios["default"].get(videoSrc);
                                  case 2:
                                    resp = _context4.sent;
                                    matched = match.exec(resp.data);
                                    if (!matched) {
                                      setTimeout(function () {
                                        return resolve();
                                      }, 1000);
                                    } else {
                                      video.src = videoSrc;
                                      video.addEventListener('loadedmetadata', function () {
                                        var now = (0, _moment["default"])().toString();
                                        console.log(camera.psn, now, 'hlsEvent', 'loadedmetadata');
                                        video.play();
                                      });
                                      reject();
                                    }
                                  case 5:
                                  case "end":
                                    return _context4.stop();
                                }
                              }, _callee4);
                            }));
                            return function (_x8, _x9) {
                              return _ref5.apply(this, arguments);
                            };
                          }()));
                        case 6:
                          _context5.prev = 6;
                          _context5.t0 = _context5["catch"](0);
                          return _context5.abrupt("return", Promise.reject());
                        case 9:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5, null, [[0, 6]]);
                  }));
                  return function (_x6, _x7) {
                    return _ref4.apply(this, arguments);
                  };
                }(), Promise.resolve());
              } catch (err) {
                console.log('err', err);
              }
            }
            videoWaitingListenerRef.current = function () {
              // 로딩이 너무 자주 일어나서 주석처리함.
              // const now = moment().toString();
              // console.log(camera.psn, now, "hlsEvent", "waiting");
              // setLoading(true);
              // setPlaying(false);
              // setWaiting({});
            };
            video.addEventListener('waiting', videoWaitingListenerRef.current);
            videoPlayingListenerRef.current = function () {
              // const now = moment().toString();
              // console.log(camera.psn, now, "set loading to false", "playing");
              setLoading(false);
              setPlaying(true);
              // setWaiting(undefined);
            };
            video.addEventListener('playing', videoPlayingListenerRef.current);
            videoPlayListenerRef.current = function () {
              // const now = moment().toString();
              // console.log(camera.psn, now, "set loading to false", "play");
              setLoading(false);
              setPlaying(true);
              // setWaiting(undefined);
            };
            video.addEventListener('play', videoPlayListenerRef.current);
            videoPauseListenerRef.current = function () {
              // const now = moment().toString();
              // console.log(camera.psn, now, "pause");
              setLoading(true);
              setPlaying(false);
              // setWaiting(undefined);
            };
            video.addEventListener('pause', videoPauseListenerRef.current);
          }
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  })), [camera, email, loginInfo, disabled, dir, retryConnect, onChannelChange]);
  var retryPlay = (0, _react.useCallback)(function () {
    if (loginInfo && camera && email) {
      var time_ms = 10 * 1000;
      var max = 6 * 5;
      var count = 0;
      var interval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _resp$data2;
        var resp, active;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _pittaModules.API.getCamInfo(email, loginInfo.user_token, camera.psn, tokenType);
            case 2:
              resp = _context7.sent;
              active = (_resp$data2 = resp.data) === null || _resp$data2 === void 0 || (_resp$data2 = _resp$data2.response) === null || _resp$data2 === void 0 || (_resp$data2 = _resp$data2['device info']) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.active;
              console.log(camera.psn, new Date(), 'check cam info', 'active', active, 'retryConnect', retryConnect, 'count', count);
              if (active === 'on') {
                clearInterval(interval);
                setTimeout(function () {
                  console.log(camera.psn, new Date(), 'check cam info', 'startPlay');
                  if (CLOUD_NATIVE) {
                    startCNPlay();
                  } else {
                    startPlay();
                  }
                }, 5 * 1000);
              }
              count++;
              if (count >= max) {
                clearInterval(interval);
                setRetryConnect(false);
                setFailToConnect(true);
              }
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })), time_ms);
      return function () {
        clearInterval(interval);
      };
    }
    return function () {};
  }, [loginInfo, camera, email, startPlay]);
  (0, _react.useEffect)(function () {
    if (retryConnect && retryConnect2 && camera) {
      console.log(camera === null || camera === void 0 ? void 0 : camera.psn, new Date(), 'check cam info', 'retryConnect', retryConnect);
      return retryPlay();
    }
  }, [camera, retryConnect, retryConnect2, retryPlay]);
  (0, _react.useEffect)(function () {
    var changeMic = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _audioStreamRef$curre, stream, audioTrack, sender, audioContent, audioStream, analyser, frequencyArray, doDraw;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              if (peerConnection.current) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("return");
            case 3:
              if (!enableMic) {
                _context8.next = 26;
                break;
              }
              _context8.next = 6;
              return navigator.mediaDevices.getUserMedia({
                video: false,
                audio: {
                  autoGainControl: true,
                  echoCancellation: true,
                  noiseSuppression: false
                }
              });
            case 6:
              stream = _context8.sent;
              audioStreamRef.current = stream;
              audioTrack = stream.getAudioTracks()[0]; // localStream.current.addTrack(audioTrack);
              if (localView.current) {
                localView.current.muted = true;
                localView.current.volume = 0;
              }
              sender = peerConnection.current.getSenders().find(function (s) {
                var _s$track;
                return ((_s$track = s.track) === null || _s$track === void 0 ? void 0 : _s$track.kind) === 'audio';
              }); // console.log("CloudNative1", "sender", sender);
              sender === null || sender === void 0 ? void 0 : sender.replaceTrack(audioTrack);
              (_audioStreamRef$curre = audioStreamRef.current) === null || _audioStreamRef$curre === void 0 ? void 0 : _audioStreamRef$curre.getTracks().forEach(function (track) {
                track.onended = function (evt) {
                  // console.log("CloudNative1", "track onended", evt);
                  if (audioStreamRef.current) {
                    audioStreamRef.current.getTracks().forEach(function (track) {
                      return track.stop();
                    });
                  }
                  audioStreamRef.current = null;
                  onNoMicPerm === null || onNoMicPerm === void 0 ? void 0 : onNoMicPerm();
                };
              });
              audioContent = new AudioContext();
              audioStream = audioContent.createMediaStreamSource(stream);
              analyser = audioContent.createAnalyser();
              audioStream.connect(analyser);
              analyser.fftSize = 2048;
              analyser.minDecibels = -100;
              analyser.maxDecibels = 0;
              analyser.smoothingTimeConstant = 0.8;
              frequencyArray = new Uint8Array(analyser.frequencyBinCount);
              doDraw = function doDraw() {
                analyser.getByteFrequencyData(frequencyArray);
                var adjustedLength = _lodash["default"].slice(frequencyArray, 80, 180);
                setAudioLevel(_lodash["default"].mean(adjustedLength));
              };
              audioAnimationRef.current = setInterval(doDraw, 250);
              _context8.next = 28;
              break;
            case 26:
              if (audioStreamRef.current) {
                audioStreamRef.current.getTracks().forEach(function (track) {
                  return track.stop();
                });
              }
              audioStreamRef.current = null;
            case 28:
              _context8.next = 32;
              break;
            case 30:
              _context8.prev = 30;
              _context8.t0 = _context8["catch"](0);
            case 32:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[0, 30]]);
      }));
      return function changeMic() {
        return _ref7.apply(this, arguments);
      };
    }();
    changeMic();
  }, [enableMic, onNoMicPerm]);
  var startCNPlay = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var status, statusBody;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (!disconnectedRef.current) {
            _context9.next = 2;
            break;
          }
          return _context9.abrupt("return", true);
        case 2:
          _context9.prev = 2;
          _context9.next = 5;
          return _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
            command: 'PlayLiveView',
            email: email,
            user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
            tokenType: tokenType,
            psn: camera === null || camera === void 0 ? void 0 : camera.psn,
            param1: prevDirectionRef.current ? "".concat(prevDirectionRef.current) : undefined
          });
        case 5:
          status = _context9.sent;
          statusBody = status.data;
          if (typeof statusBody === 'string') {
            statusBody = JSON.parse(statusBody);
          }

          // console.log("CloudNative1", "try to startCNPlay", statusBody);
          if (statusBody.status === 'LiveStopped' || statusBody.status === 'onLiveStreaming') {
            _context9.next = 10;
            break;
          }
          return _context9.abrupt("return", false);
        case 10:
          // getEndpoints(presignedUrl, `${camera?.psn}_live`);
          setReadyToConnect(true);
          _context9.next = 16;
          break;
        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", false);
        case 16:
          _context9.prev = 16;
          setFailToConnect(false);
          // console.log(
          //   "CloudNative1",
          //   "play",
          //   camera?.psn,
          //   email,
          //   // kinesisVideoClient,
          //   loginInfo?.user_token
          // );
          return _context9.abrupt("return", true);
        case 21:
          _context9.prev = 21;
          _context9.t1 = _context9["catch"](16);
          setFailToConnect(true);
          onSetError(_context9.t1.message);
          console.error(_context9.t1.message);
        case 26:
          return _context9.abrupt("return", true);
        case 27:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[2, 13], [16, 21]]);
  })), [camera === null || camera === void 0 ? void 0 : camera.psn, email, loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token, tokenType]);
  var tryPlay = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var runs, tryStop, requested, cam, playLiveView, timer;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          runs = 5;
          tryStop = 2;
          requested = false;
          cam = camera;
          playLiveView = /*#__PURE__*/function () {
            var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
              var s;
              return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                while (1) switch (_context10.prev = _context10.next) {
                  case 0:
                    if (requested) {
                      _context10.next = 24;
                      break;
                    }
                    requested = true;
                    _context10.prev = 2;
                    _context10.next = 5;
                    return startCNPlay();
                  case 5:
                    s = _context10.sent;
                    runs--;
                    // 12383 수정
                    console.log('LiveViewPlayer', 'sending StopLiveView to', cam === null || cam === void 0 ? void 0 : cam.psn, 'after PlayLiveView x10', s, runs, tryStop);
                    if (!(s || runs <= 0)) {
                      _context10.next = 20;
                      break;
                    }
                    tryStop--;
                    if (!(!s && tryStop > 0)) {
                      _context10.next = 16;
                      break;
                    }
                    _context10.next = 13;
                    return _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
                      command: 'StopLiveView',
                      email: email,
                      user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
                      tokenType: tokenType,
                      psn: cam === null || cam === void 0 ? void 0 : cam.psn
                    });
                  case 13:
                    runs = 10;
                    _context10.next = 17;
                    break;
                  case 16:
                    if (!s) {
                      console.log('after', 'here?');
                      setFailToConnect(true);
                      setRetryConnect(false);
                      clearInterval(timer);
                    } else {
                      clearInterval(timer);
                    }
                  case 17:
                    requested = false;
                    _context10.next = 21;
                    break;
                  case 20:
                    console.log('LiveViewPlayer', 'Dashcam is busy...');
                  case 21:
                    _context10.prev = 21;
                    requested = false;
                    return _context10.finish(21);
                  case 24:
                  case "end":
                    return _context10.stop();
                }
              }, _callee10, null, [[2,, 21, 24]]);
            }));
            return function playLiveView() {
              return _ref10.apply(this, arguments);
            };
          }();
          playLiveView();
          timer = setInterval(playLiveView, 2000);
          return _context11.abrupt("return", timer);
        case 8:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  })), [startCNPlay]);
  var connectLiveView = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var _q1$searchParams$get;
    var streamName, resp2, q1;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          streamName = "".concat(camera === null || camera === void 0 ? void 0 : camera.psn, "_live");
          _context12.next = 3;
          return _pittaModules.jwtAxiosInst.post("/CloudService/LivePresignURL", {
            streamName: streamName,
            role: 'VIEWER',
            psn: camera === null || camera === void 0 ? void 0 : camera.psn
          });
        case 3:
          resp2 = _context12.sent;
          q1 = new URL(resp2.data.url);
          clientIDRef.current = (_q1$searchParams$get = q1.searchParams.get('X-Amz-ClientId')) !== null && _q1$searchParams$get !== void 0 ? _q1$searchParams$get : undefined;

          // console.log(
          //   "CloudNative1",
          //   "LivePresignURL",
          //   resp2.data,
          //   "clientID",
          //   clientIDRef.current
          // );

          setPresignedUrl(resp2.data);
        case 7:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  })), [camera === null || camera === void 0 ? void 0 : camera.psn]);
  var getEndpoints = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(presignedUrl) {
      var _signalingClient$curr2, _signalingClient$curr7, _signalingClient$curr8, _signalingClient$curr9, _signalingClient$curr10, _peerConnection$curre12, _peerConnection$curre14, _peerConnection$curre15, _peerConnection$curre16;
      var channelARN, iceServers, _signalingClient$curr, _peerConnection$curre, noAudio, _signalingClient$curr13, _peerConnection$curre19, _signalingClient$curr14;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            if (!(main && !onNoMicPerm)) {
              _context16.next = 2;
              break;
            }
            return _context16.abrupt("return");
          case 2:
            if (!signalingClient.current) {
              _context16.next = 4;
              break;
            }
            return _context16.abrupt("return");
          case 4:
            if (!peerConnection.current) {
              _context16.next = 6;
              break;
            }
            return _context16.abrupt("return");
          case 6:
            if (!localStream.current) {
              _context16.next = 8;
              break;
            }
            return _context16.abrupt("return");
          case 8:
            if (!remoteStream.current) {
              _context16.next = 10;
              break;
            }
            return _context16.abrupt("return");
          case 10:
            // Get signaling channel ARN
            channelARN = presignedUrl.channelARN; // console.log(
            //   "CloudNative1",
            //   "clientID",
            //   clientIDRef.current,
            //   "[VIEWER] Channel ARN: ",
            //   channelARN
            // );
            // const endpointsByProtocol = presignedUrl.endpointsByProtocol;
            // console.log(
            //   "CloudNative1",
            //   "clientID",
            //   clientIDRef.current,
            //   "[VIEWER] Endpoints: ",
            //   presignedUrl.url
            // );
            iceServers = presignedUrl.iceServers; // console.log(
            //   "CloudNative1",
            //   "clientID",
            //   clientIDRef.current,
            //   "[VIEWER] ICE servers: ",
            //   iceServers
            // );
            signalingClient.current = new KVSWebRTC.SignalingClient({
              requestSigner: new CustomSigner(presignedUrl.url),
              channelARN: channelARN,
              channelEndpoint: presignedUrl.url,
              role: KVSWebRTC.Role.VIEWER,
              region: presignedUrl.region,
              clientId: clientIDRef.current
              // systemClockOffset: kvsVideo.config.systemClockOffset,
            });
            peerConnection.current = new RTCPeerConnection({
              iceServers: iceServers,
              iceTransportPolicy: 'relay'
            });
            if (!disconnectedRef.current) {
              _context16.next = 20;
              break;
            }
            (_signalingClient$curr = signalingClient.current) === null || _signalingClient$curr === void 0 ? void 0 : _signalingClient$curr.close();
            signalingClient.current = null;
            (_peerConnection$curre = peerConnection.current) === null || _peerConnection$curre === void 0 ? void 0 : _peerConnection$curre.close();
            peerConnection.current = null;
            return _context16.abrupt("return");
          case 20:
            // Once the signaling channel connection is open, connect to the webcam and create an offer to send to the master
            noAudio = false;
            (_signalingClient$curr2 = signalingClient.current) === null || _signalingClient$curr2 === void 0 ? void 0 : _signalingClient$curr2.on('open', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
              var _peerConnection$curre5;
              var _localStream$current, _peerConnection$curre3, transceiver, _peerConnection$curre4, audioTransceiver, offer, _peerConnection$curre6, _peerConnection$curre7, _signalingClient$curr5, timer, _signalingClient$curr6, _peerConnection$curre9;
              return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                while (1) switch (_context13.prev = _context13.next) {
                  case 0:
                    // console.log(
                    //   "CloudNative1",
                    //   "clientID",
                    //   clientIDRef.current,
                    //   "[VIEWER] Connected to signaling service",
                    //   "navigator.mediaDevices",
                    //   !!navigator.mediaDevices
                    // );

                    sigClientPingRef.current = setInterval(function () {
                      var _signalingClient$curr3;
                      //@ts-ignore
                      (_signalingClient$curr3 = signalingClient.current) === null || _signalingClient$curr3 === void 0 || (_signalingClient$curr3 = _signalingClient$curr3.websocket) === null || _signalingClient$curr3 === void 0 ? void 0 : _signalingClient$curr3.send('ping');
                    }, 30 * 1000);

                    // Get a stream from the webcam, add it to the peer connection, and display it in the local view
                    _context13.prev = 1;
                    _context13.next = 4;
                    return navigator.mediaDevices.getUserMedia({
                      // video: { width: { ideal: 640 }, height: { ideal: 480 } },
                      video: false,
                      // audio: false,
                      audio: isPublic ? false : {
                        // autoGainControl: true,
                        // echoCancellation: true,
                        // noiseSuppression: false,
                      }
                    });
                  case 4:
                    localStream.current = _context13.sent;
                    (_localStream$current = localStream.current) === null || _localStream$current === void 0 ? void 0 : _localStream$current.getTracks().forEach(function (track) {
                      if (localStream.current) {
                        var _peerConnection$curre2;
                        (_peerConnection$curre2 = peerConnection.current) === null || _peerConnection$curre2 === void 0 ? void 0 : _peerConnection$curre2.addTrack(track, localStream.current);
                      }
                    });
                    // 마이크 disable
                    // if (localStream.current) {
                    //   const track = _.first(localStream.current.getAudioTracks());
                    //   if (track) {
                    //     track.enabled = false;
                    //   }
                    // }

                    // if (localView.current) {
                    //   localView.current.srcObject = localStream.current;
                    // }
                    _context13.next = 12;
                    break;
                  case 8:
                    _context13.prev = 8;
                    _context13.t0 = _context13["catch"](1);
                    // Could not find webcam
                    // console.error(
                    //   "CloudNative1",
                    //   "clientID",
                    //   clientIDRef.current,
                    //   "[VIEWER] Could not find webcam",
                    //   e.message,
                    //   browserName
                    // );
                    // console.log(
                    //   "CloudNative1",
                    //   "clientID",
                    //   clientIDRef.current,
                    //   "onNoMicPerm"
                    // );
                    if (browserName === 'ios-webview' && navigator.mediaDevices) {
                      onNoMicPerm === null || onNoMicPerm === void 0 ? void 0 : onNoMicPerm(true);
                    } else if (browserName !== 'chromium-webview') {
                      onNoMicPerm === null || onNoMicPerm === void 0 ? void 0 : onNoMicPerm();
                    }
                    noAudio = true;
                  case 12:
                    try {
                      transceiver = (_peerConnection$curre3 = peerConnection.current) === null || _peerConnection$curre3 === void 0 ? void 0 : _peerConnection$curre3.addTransceiver('video');
                      if (transceiver) {
                        transceiver.direction = 'recvonly';
                      }
                      if (noAudio) {
                        audioTransceiver = (_peerConnection$curre4 = peerConnection.current) === null || _peerConnection$curre4 === void 0 ? void 0 : _peerConnection$curre4.addTransceiver('audio');
                        if (audioTransceiver) {
                          audioTransceiver.direction = 'recvonly';
                        }
                      }
                    } catch (e) {
                      console.error(e.message);
                    }

                    // Create an SDP offer and send it to the master
                    _context13.next = 15;
                    return (_peerConnection$curre5 = peerConnection.current) === null || _peerConnection$curre5 === void 0 ? void 0 : _peerConnection$curre5.createOffer({
                      offerToReceiveAudio: true,
                      offerToReceiveVideo: true
                    });
                  case 15:
                    offer = _context13.sent;
                    if (!(offer && offer.sdp)) {
                      _context13.next = 25;
                      break;
                    }
                    _context13.next = 19;
                    return (_peerConnection$curre6 = peerConnection.current) === null || _peerConnection$curre6 === void 0 ? void 0 : _peerConnection$curre6.setLocalDescription(offer);
                  case 19:
                    if (!((_peerConnection$curre7 = peerConnection.current) !== null && _peerConnection$curre7 !== void 0 && _peerConnection$curre7.localDescription)) {
                      _context13.next = 25;
                      break;
                    }
                    // 대시캠에서 SDP offer를 못받는 이슈가 있어서,
                    // sdp offer 보낸 후, sdp answer를 못받으면
                    // 받을때 까지 2초간격으로 5회까지 sdp offer를 다시 보냄
                    timer = setInterval(function () {
                      var _peerConnection$curre8;
                      // console.log(
                      //   "CloudNative1",
                      //   "clientID",
                      //   clientIDRef.current,
                      //   "[VIEWER] Sending SDP offer",
                      //   nTrySendSDPRef.current,
                      //   receivedSDPRef.current
                      // );
                      if (nTrySendSDPRef.current > 5 || receivedSDPRef.current) {
                        if (nTrySendSDPRef.current > 5) {
                          setFailToConnect(true);
                        }
                        return clearInterval(timer);
                      }
                      if ((_peerConnection$curre8 = peerConnection.current) !== null && _peerConnection$curre8 !== void 0 && _peerConnection$curre8.localDescription) {
                        var _signalingClient$curr4;
                        (_signalingClient$curr4 = signalingClient.current) === null || _signalingClient$curr4 === void 0 ? void 0 : _signalingClient$curr4.sendSdpOffer(peerConnection.current.localDescription);
                      }
                      nTrySendSDPRef.current++;
                    }, 5000); // console.log(
                    //   "CloudNative1",
                    //   "clientID",
                    //   clientIDRef.current,
                    //   "[VIEWER] Sending SDP offer"
                    // );
                    _context13.next = 23;
                    return (0, _pittaModules.sleep)(100);
                  case 23:
                    (_signalingClient$curr5 = signalingClient.current) === null || _signalingClient$curr5 === void 0 ? void 0 : _signalingClient$curr5.sendSdpOffer(peerConnection.current.localDescription);
                    sendingSDPRef.current = true;
                  case 25:
                    if (!disconnectedRef.current) {
                      _context13.next = 33;
                      break;
                    }
                    (_signalingClient$curr6 = signalingClient.current) === null || _signalingClient$curr6 === void 0 ? void 0 : _signalingClient$curr6.close();
                    signalingClient.current = null;
                    (_peerConnection$curre9 = peerConnection.current) === null || _peerConnection$curre9 === void 0 ? void 0 : _peerConnection$curre9.close();
                    peerConnection.current = null;
                    if (localStream.current) {
                      localStream.current.getTracks().forEach(function (track) {
                        return track.stop();
                      });
                      localStream.current = null;
                    }
                    if (remoteStream.current) {
                      remoteStream.current.getTracks().forEach(function (track) {
                        return track.stop();
                      });
                      remoteStream.current = null;
                    }
                    return _context13.abrupt("return");
                  case 33:
                  case "end":
                    return _context13.stop();
                }
              }, _callee13, null, [[1, 8]]);
            })));

            // When the SDP answer is received back from the master, add it to the peer connection.
            (_signalingClient$curr7 = signalingClient.current) === null || _signalingClient$curr7 === void 0 ? void 0 : _signalingClient$curr7.on('sdpAnswer', /*#__PURE__*/function () {
              var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(answer) {
                var _peerConnection$curre10;
                return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      // console.log(
                      //   "CloudNative1",
                      //   "clientID",
                      //   clientIDRef.current,
                      //   "[VIEWER] Received SDP answer",
                      //   answer.sdp
                      // );
                      receivedSDPRef.current = true;
                      _context14.next = 3;
                      return (_peerConnection$curre10 = peerConnection.current) === null || _peerConnection$curre10 === void 0 ? void 0 : _peerConnection$curre10.setRemoteDescription(answer);
                    case 3:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              return function (_x11) {
                return _ref14.apply(this, arguments);
              };
            }());

            // When an ICE candidate is received from the master, add it to the peer connection.
            (_signalingClient$curr8 = signalingClient.current) === null || _signalingClient$curr8 === void 0 ? void 0 : _signalingClient$curr8.on('iceCandidate', function (candidate) {
              var _peerConnection$curre11;
              // console.log(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "[VIEWER] Received ICE candidate"
              // );
              (_peerConnection$curre11 = peerConnection.current) === null || _peerConnection$curre11 === void 0 ? void 0 : _peerConnection$curre11.addIceCandidate(candidate);
            });
            (_signalingClient$curr9 = signalingClient.current) === null || _signalingClient$curr9 === void 0 ? void 0 : _signalingClient$curr9.on('close', function () {
              // console.log(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "[VIEWER] Disconnected from signaling channel"
              // );
              // Handle client closures
            });
            (_signalingClient$curr10 = signalingClient.current) === null || _signalingClient$curr10 === void 0 ? void 0 : _signalingClient$curr10.on('error', function (error) {
              // console.error(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "[VIEWER] Signaling client error: ",
              //   error
              // );
              // Handle client errors
            });
            // Send any ICE candidates generated by the peer connection to the other peer
            (_peerConnection$curre12 = peerConnection.current) === null || _peerConnection$curre12 === void 0 ? void 0 : _peerConnection$curre12.addEventListener('icecandidate', function (_ref15) {
              var candidate = _ref15.candidate;
              if (disconnectedRef.current) {
                var _signalingClient$curr11, _peerConnection$curre13;
                (_signalingClient$curr11 = signalingClient.current) === null || _signalingClient$curr11 === void 0 ? void 0 : _signalingClient$curr11.close();
                signalingClient.current = null;
                (_peerConnection$curre13 = peerConnection.current) === null || _peerConnection$curre13 === void 0 ? void 0 : _peerConnection$curre13.close();
                peerConnection.current = null;
                if (localStream.current) {
                  localStream.current.getTracks().forEach(function (track) {
                    return track.stop();
                  });
                  localStream.current = null;
                }
                if (remoteStream.current) {
                  remoteStream.current.getTracks().forEach(function (track) {
                    return track.stop();
                  });
                  remoteStream.current = null;
                }
                return;
              }
              if (candidate) {
                var _signalingClient$curr12;
                // console.log(
                //   "CloudNative1",
                //   "clientID",
                //   clientIDRef.current,
                //   "[VIEWER] Generated ICE candidate"
                // );
                // console.log(
                //   "CloudNative1",
                //   "clientID",
                //   clientIDRef.current,
                //   "[VIEWER] Sending ICE candidate"
                // );
                (_signalingClient$curr12 = signalingClient.current) === null || _signalingClient$curr12 === void 0 ? void 0 : _signalingClient$curr12.sendIceCandidate(candidate);
              }
            });

            // As remote tracks are received, add them to the remote view
            (_peerConnection$curre14 = peerConnection.current) === null || _peerConnection$curre14 === void 0 ? void 0 : _peerConnection$curre14.addEventListener('track', function (event) {
              // console.log(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "[VIEWER] Received remote track",
              //   event
              // );
              if (remoteView.current && !remoteView.current.srcObject) {
                remoteStream.current = event.streams[0];
                remoteView.current.srcObject = event.streams[0];
              }
            });
            (_peerConnection$curre15 = peerConnection.current) === null || _peerConnection$curre15 === void 0 ? void 0 : _peerConnection$curre15.addEventListener('iceconnectionstatechange', function (event) {
              // console.log(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "[VIEWER] Iceconnection State Change",
              //   event
              // );
            });
            (_peerConnection$curre16 = peerConnection.current) === null || _peerConnection$curre16 === void 0 ? void 0 : _peerConnection$curre16.addEventListener('connectionstatechange', /*#__PURE__*/function () {
              var _ref16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(event) {
                var _peerConnection$curre17, _peerConnection$curre18;
                return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                  while (1) switch (_context15.prev = _context15.next) {
                    case 0:
                      if (!(((_peerConnection$curre17 = peerConnection.current) === null || _peerConnection$curre17 === void 0 ? void 0 : _peerConnection$curre17.connectionState) === 'connected')) {
                        _context15.next = 7;
                        break;
                      }
                      // console.log(
                      //   "LiveViewPlayer",
                      //   "set loading to false",
                      //   "peerConnection",
                      //   "connected"
                      // );
                      setLoading(false);
                      setRetryConnect(false);
                      setPlaying(true);
                      if (localStream.current) {
                        localStream.current.getTracks().forEach(function (track) {
                          var _localStream$current2;
                          track.stop();
                          (_localStream$current2 = localStream.current) === null || _localStream$current2 === void 0 ? void 0 : _localStream$current2.removeTrack(track);
                        });
                        localStream.current = null;
                        // const audioTrack = localStream.current.getAudioTracks()[0];
                        // if (audioTrack) {
                        //   audioTrack.stop();
                        //   localStream.current.removeTrack(audioTrack);
                        // }
                      }
                      _context15.next = 25;
                      break;
                    case 7:
                      if (!(((_peerConnection$curre18 = peerConnection.current) === null || _peerConnection$curre18 === void 0 ? void 0 : _peerConnection$curre18.connectionState) === 'disconnected')) {
                        _context15.next = 25;
                        break;
                      }
                      _context15.next = 10;
                      return resetConnection();
                    case 10:
                      if (!(subscriptionInfo !== null && subscriptionInfo !== void 0 && subscriptionInfo.servicePlanName && ((subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName) === 'free' || (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.servicePlanName.indexOf('lite')) > -1))) {
                        _context15.next = 21;
                        break;
                      }
                      if (!(usageInfoRef.current && (usageInfoRef.current.LimitLiveView === 0 || usageInfoRef.current.liveViewDayUsage + usedTimeRef.current < usageInfoRef.current.LimitLiveView))) {
                        _context15.next = 18;
                        break;
                      }
                      connectLiveView();
                      _context15.next = 15;
                      return tryPlay();
                    case 15:
                      retryTimer.current = _context15.sent;
                      _context15.next = 19;
                      break;
                    case 18:
                      setLoading(false);
                    case 19:
                      _context15.next = 25;
                      break;
                    case 21:
                      connectLiveView();
                      _context15.next = 24;
                      return tryPlay();
                    case 24:
                      retryTimer.current = _context15.sent;
                    case 25:
                    case "end":
                      return _context15.stop();
                  }
                }, _callee15);
              }));
              return function (_x12) {
                return _ref16.apply(this, arguments);
              };
            }());
            // setEndpointsByProtocol(result);
            // console.log(
            //   "CloudNative1",
            //   "clientID",
            //   clientIDRef.current,
            //   "[VIEWER] Starting viewer connection",
            //   disconnectedRef.current
            // );
            if (!disconnectedRef.current) {
              _context16.next = 38;
              break;
            }
            (_signalingClient$curr13 = signalingClient.current) === null || _signalingClient$curr13 === void 0 ? void 0 : _signalingClient$curr13.close();
            signalingClient.current = null;
            (_peerConnection$curre19 = peerConnection.current) === null || _peerConnection$curre19 === void 0 ? void 0 : _peerConnection$curre19.close();
            peerConnection.current = null;
            return _context16.abrupt("return");
          case 38:
            (_signalingClient$curr14 = signalingClient.current) === null || _signalingClient$curr14 === void 0 ? void 0 : _signalingClient$curr14.open();
          case 39:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    return function (_x10) {
      return _ref12.apply(this, arguments);
    };
  }(), [browserName, connectLiveView, isPublic, main, onNoMicPerm, resetConnection, tryPlay]);
  (0, _react.useEffect)(function () {
    if (presignedUrl && readyToConnect && !disconnectedRef.current) {
      // console.log(
      //   "CloudNative1",
      //   "clientID",
      //   clientIDRef.current,
      //   "start getEndpoints",
      //   disconnectedRef.current
      // );
      getEndpoints(presignedUrl);
    }
  }, [getEndpoints, presignedUrl, readyToConnect]);
  (0, _react.useEffect)(function () {
    // console.log(
    //   "CloudNative1",
    //   "update camera",
    //   "prev",
    //   prevCamRef.current,
    //   "camera",
    //   camera,
    //   "isEqual",
    //   _.isEqual(prevCamRef.current, camera),
    //   "CLOUD_NATIVE",
    //   CLOUD_NATIVE,
    //   "email",
    //   email
    // );
    // camera가 undefined였다가 설정되는 경우 connection 정리하는 문제를 위해 수정
    if (prevCamRef.current === undefined) {
      prevCamRef.current = camera;
      return;
    }

    // 변경된 camera object가 기존 camera랑 같은 경우는 무시
    if (!_lodash["default"].isEqual(prevCamRef.current, camera)) {
      return;
    }
    if (!email) return;
    if (camera) {
      var cam = camera;
      var p = remoteView.current;
      var local = localView.current;
      prevCamRef.current = camera;
      return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (CLOUD_NATIVE) {
                _context17.next = 2;
                break;
              }
              return _context17.abrupt("return");
            case 2:
              // console.log(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "start removing connection...",
              //   camera
              // );
              if (sigClientPingRef.current !== null) {
                clearInterval(sigClientPingRef.current);
                sigClientPingRef.current = null;
              }
              disconnectedRef.current = true;
              if (retryTimer.current !== undefined) {
                clearInterval(retryTimer.current);
              }
              if (audioStreamRef.current) {
                // console.log(
                //   "CloudNative1",
                //   "clientID",
                //   clientIDRef.current,
                //   "sending TwoWayStop to",
                //   cam.psn
                // );
                audioStreamRef.current.getTracks().forEach(function (track) {
                  return track.stop();
                });
                audioStreamRef.current = null;
                _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
                  command: 'TwoWayStop',
                  email: email,
                  user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
                  tokenType: tokenType,
                  psn: cam.psn
                });
              }
              _context17.next = 8;
              return (0, _pittaModules.sleep)(1500);
            case 8:
              if (!sendingSDPRef.current) {
                // kvs 채널 연결이 정상적으로 되지 않은 경우를 대비해 Stop메시지 추가로 보냄 (20220714)
                // TwoWayStart한 경우는 라이브뷰 정상연결된 경우로 StopLiveView 안보냄
                // console.log(
                //   "CloudNative1",
                //   "clientID",
                //   clientIDRef.current,
                //   "sending StopLiveView2 to",
                //   cam.psn
                // );
                _pittaModules.jwtAxiosInst.post("/IoT/devicecommand", {
                  command: 'StopLiveView',
                  email: email,
                  user_token: loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token,
                  tokenType: tokenType,
                  psn: cam.psn
                });
              }

              // console.log(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "removing webrtc...",
              //   cam.psn
              // );
              p === null || p === void 0 ? void 0 : p.pause();
              local === null || local === void 0 ? void 0 : local.pause();
              setHlsInst(undefined);
              setPresignedUrl(undefined);
              setReadyToConnect(false);

              // console.log(
              //   "CloudNative1",
              //   "clientID",
              //   clientIDRef.current,
              //   "close signaling client...",
              //   cam.psn,
              //   signalingClient.current
              // );
              // webrtc 정리
              if (signalingClient.current) {
                signalingClient.current.close();
                signalingClient.current = null;
              }
              if (peerConnection.current) {
                peerConnection.current.close();
                peerConnection.current = null;
              }
              if (localStream.current) {
                localStream.current.getTracks().forEach(function (track) {
                  return track.stop();
                });
                localStream.current = null;
              }
              if (remoteStream.current) {
                remoteStream.current.getTracks().forEach(function (track) {
                  return track.stop();
                });
                remoteStream.current = null;
              }
              if (local) {
                local.srcObject = null;
              }
              if (p) {
                p.srcObject = null;
              }
              disconnectedRef.current = false;
              prevCamRef.current = undefined;
            case 22:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
    }
    return function () {};
  }, [CLOUD_NATIVE, camera, email, loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.user_token, tokenType]);
  (0, _react.useEffect)(function () {
    // console.log(
    //   "LiveViewPlayer",
    //   CLOUD_NATIVE,
    //   disabled,
    //   autoPlayable,
    //   camera
    // );
    if (CLOUD_NATIVE && !disabled && autoPlayable !== undefined && camera) {
      stopLiveview.current = true;
      connectLiveView();
    }
  }, [CLOUD_NATIVE, autoPlayable, camera, connectLiveView, disabled]);
  (0, _react.useEffect)(function () {
    if (CLOUD_NATIVE && !disabled && autoPlayable !== undefined && camera) {
      // 연결 시도 타이머
      var _t;
      tryPlay().then(function (v) {
        return _t = v;
      });
      return function () {
        if (_t) {
          clearInterval(_t);
        }
      };
    }
  }, [CLOUD_NATIVE, autoPlayable, camera, disabled, tryPlay]);
  (0, _react.useEffect)(function () {
    if (CLOUD_NATIVE === false && autoPlayable !== undefined) {
      startPlay();
    }
  }, [CLOUD_NATIVE, startPlay, autoPlayable]);
  (0, _react.useEffect)(function () {
    if (hlsInst) {
      var hls = hlsInst;
      return function () {
        hls.detachMedia();
        hls.destroy();
        var video = remoteView.current;
        if (video) {
          if (videoWaitingListenerRef.current) {
            video.removeEventListener('waiting', videoWaitingListenerRef.current);
            videoWaitingListenerRef.current = undefined;
          }
          if (videoPlayingListenerRef.current) {
            video.removeEventListener('playing', videoPlayingListenerRef.current);
            videoPlayingListenerRef.current = undefined;
          }
          if (videoPlayListenerRef.current) {
            video.removeEventListener('play', videoPlayListenerRef.current);
            videoPlayListenerRef.current = undefined;
          }
          if (videoPauseListenerRef.current) {
            video.removeEventListener('pause', videoPauseListenerRef.current);
            videoPauseListenerRef.current = undefined;
          }
        }
      };
    }
  }, [hlsInst]);
  var renderCtrlIcon = (0, _react.useCallback)(function (icon, _onClick, disabled) {
    return disabled ? /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.disabledCtrlIcon
    }, icon) : /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
      className: classes.ctrlIcon,
      onClick: function onClick(e) {
        e.stopPropagation();
        _onClick === null || _onClick === void 0 ? void 0 : _onClick();
      }
    }, icon);
  }, [classes.ctrlIcon, classes.disabledCtrlIcon]);
  var volumeCtrlMarkup = (0, _react.useMemo)(function () {
    var noVolume = isPublic && (camera === null || camera === void 0 ? void 0 : camera.share_audio) !== 'on';
    var volumeIcon = /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip
    // mantis - 9178, 웹 제외. 모든 툴팁 최초 진입시에만 노출(Leehj).
    , {
      open: openMuteTooltip,
      onOpen: function onOpen() {
        return setOpenMuteTooltip(true);
      },
      onClose: function onClose() {
        return setOpenMuteTooltip(false);
      },
      disableTouchListener: app || mobile,
      disableHoverListener: app || mobile,
      PopperProps: {
        disablePortal: true,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          offset: {
            enabled: true,
            offset: mobile ? '0px, -25px' : '2px, -10px'
          },
          flip: {
            enabled: false
          }
        }
      },
      title: /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "Caption"
      }, t('Mute')),
      placement: "top-start"
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
      className: classes.ctrlIcon,
      ref: volumeAnchorRef,
      disableHover: mobile,
      onClick: function onClick(e) {
        e.stopPropagation();
        setMuted(true);
        setPreVolume(volume);
        setVolume(0);
      }
    }, /*#__PURE__*/_react["default"].createElement(_VolumeUp["default"], null)));
    if (muted) {
      volumeIcon = /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip
      // mantis - 9178, 웹 제외. 모든 툴팁 최초 진입시에만 노출(Leehj).
      , {
        open: openUnMuteTooltip,
        onOpen: function onOpen() {
          return setOpenUnMuteTooltip(true);
        },
        onClose: function onClose() {
          return setOpenUnMuteTooltip(false);
        },
        disableTouchListener: app || mobile,
        disableHoverListener: app || mobile,
        PopperProps: {
          disablePortal: true,
          modifiers: {
            preventOverflow: {
              enabled: false
            },
            offset: {
              enabled: true,
              offset: mobile ? '0px, -25px' : '2px, -10px'
            },
            flip: {
              enabled: false
            }
          }
        },
        title: /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
          category: "Default",
          variant: "Caption"
        }, t('UnMute')),
        placement: "top-start"
      }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
        className: classes.ctrlIcon,
        ref: volumeAnchorRef,
        disableHover: mobile,
        onClick: function onClick(e) {
          // 라이브 음성 미공유 시, unmute버튼 눌러도 동작하지 않도록 예외처리 추가 (7271)
          if (!disableVolume) {
            e.stopPropagation();
            setMuted(false);
            if (preVolume === 0) {
              setVolume(mobile ? 100 : 50);
            } else {
              setVolume(preVolume);
            }
          }
        }
        // mantis - 12419,  Live view 소진한 상태면 버튼 비활성화 (Leehj)
        // mantis - 12439, Flip 버튼과 Fullscreen 버튼 비활성화 상태로 노출하는 현상 수정 (Leehj)
        ,
        disabled: isLimitLiveView
      }, /*#__PURE__*/_react["default"].createElement(_VolumeOff["default"], null)));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.ctrlDiv
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      onMouseEnter: function onMouseEnter() {
        return !disableVolume && setOpenVolumeMenu(true);
      },
      onMouseLeave: function onMouseLeave() {
        return !disableVolume && setOpenVolumeMenu(false);
      }
    }, !noVolume && volumeIcon, !noVolume && !muted && !mobile && openVolumeMenu && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.volumeCtrlDiv
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.VolumeSlider, {
      value: volume,
      onChange: function onChange(e, newVal) {
        return setVolume(newVal);
      }
    }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
      disableTouchListener: mobile,
      title: /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "Caption"
      }, t('Flip')),
      placement: "top",
      PopperProps: {
        disablePortal: true,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          offset: {
            enabled: true,
            offset: mobile ? '0px, -25px' : '2px, -10px'
          },
          flip: {
            enabled: false
          }
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
      className: classes.ctrlIcon,
      ref: flipAnchorRef,
      onClick: function onClick() {
        // 웹에서 FlipMenu 오픈시 컨트롤바 사라지는 이슈수정(Leehj)
        setForceViewCtrl(true);
        setHFlip(function (f) {
          return !f;
        });
        // setOpenFlipMenu((f) => !f);
      }
      // mantis - 12419, Live view 소진한 상태면 버튼 비활성화 (Leehj)
      // mantis - 12439, Flip 버튼과 Fullscreen 버튼 비활성화 상태로 노출하는 현상 수정 (Leehj)
      ,
      disabled: isLimitLiveView
    }, /*#__PURE__*/_react["default"].createElement(_Flip["default"], null))), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
      disableTouchListener: mobile,
      open: openTooltip,
      onOpen: function onOpen() {
        return setOpenTooltip(true);
      },
      onClose: function onClose() {
        return setOpenTooltip(false);
      },
      title: /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
        category: "Default",
        variant: "Caption"
      }, fullscreen ? t('Exit fullscreen') : t('Fullscreen')),
      placement: "top-end",
      PopperProps: {
        disablePortal: true,
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          offset: {
            enabled: true,
            offset: mobile ? '0px, -25px' : '2px, -10px'
          },
          flip: {
            enabled: false
          }
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.IconButton, {
      className: classes.ctrlIcon,
      onClick: handleFullscreen
      // mantis - 12419, Live view 소진한 상태면 버튼 비활성화 (Leehj)
      // mantis - 12439, Flip 버튼과 Fullscreen 버튼 비활성화 상태로 노출하는 현상 수정 (Leehj)
      ,
      disabled: isLimitLiveView
    }, fullscreen ? /*#__PURE__*/_react["default"].createElement(_FullscreenExit["default"], null) : /*#__PURE__*/_react["default"].createElement(_Fullscreen["default"], null)))));
  }, [app, camera === null || camera === void 0 ? void 0 : camera.share_audio, classes.ctrlDiv, classes.ctrlIcon, classes.volumeCtrlDiv, disableVolume, fullscreen, handleFullscreen, isPublic, mobile, muted, openMuteTooltip, openTooltip, openUnMuteTooltip, openVolumeMenu, preVolume, t, volume]);
  var removeEvent = (0, _react.useCallback)(function (ev) {
    // Remove this event from the target's cache
    var index = evCacheRef.current.findIndex(function (cachedEv) {
      return cachedEv.pointerId === ev.pointerId;
    });
    evCacheRef.current.splice(index, 1);
    delete startCoordsRef.current[ev.pointerId];
  }, []);
  var pointerupHandler = (0, _react.useCallback)(function (ev) {
    console.log(ev.type, ev);
    // Remove this pointer from the cache and reset the target's
    // background and border
    removeEvent(ev);

    // If the number of pointers down is less than two then reset diff tracker
    if (evCacheRef.current.length < 2) {
      prevDiffRef.current = -1;
    }
  }, []);
  var pointerdownHandler = (0, _react.useCallback)(function (e) {
    evCacheRef.current.push(e);
    startCoordsRef.current[e.pointerId] = {
      x: e.clientX,
      y: e.clientY
    };
    console.log('pointerDown', e);
  }, []);
  var pointermoveHandler = (0, _react.useCallback)(function (ev) {
    var prevDiff = prevDiffRef.current;
    var evCache = evCacheRef.current;
    var startCoords = startCoordsRef.current; // 시작 좌표 저장용

    // Find this event in the cache and update its record with this event
    var index = evCache.findIndex(function (cachedEv) {
      return cachedEv.pointerId === ev.pointerId;
    });
    evCache[index] = ev;

    // If two pointers are down, check for pinch gestures
    if (evCache.length === 2) {
      // Calculate the distance between the two pointers
      var curDiff = Math.abs(evCache[0].clientX - evCache[1].clientX);
      if (prevDiff > 0) {
        if (curDiff > prevDiff) {
          // The distance between the two pointers has increased
          console.log('Pinch moving OUT -> Zoom in', curDiff, ev);
          var newScale = Math.min(videoScale + curDiff / 2000, 2);
          var maxMove = Math.round((newScale - 1) / 2 * 100);
          setVideoMoveX(function (x) {
            return Math.max(Math.min(x, maxMove), -maxMove);
          });
          setVideoMoveY(function (x) {
            return Math.max(Math.min(x, maxMove), -maxMove);
          });
          setVideoScale(newScale);
        }
        if (curDiff < prevDiff) {
          // The distance between the two pointers has decreased
          console.log('Pinch moving IN -> Zoom out', curDiff, ev);
          var _newScale = Math.max(videoScale - curDiff / 2000, 1);
          var _maxMove = Math.round((_newScale - 1) / 2 * 100);
          setVideoMoveX(function (x) {
            return Math.max(Math.min(x, _maxMove), -_maxMove);
          });
          setVideoMoveY(function (x) {
            return Math.max(Math.min(x, _maxMove), -_maxMove);
          });
          setVideoScale(_newScale);
        }
      }

      // Cache the distance for the next move event
      prevDiffRef.current = curDiff;
    } else if (evCache.length === 1) {
      var _startCoords$pointerI, _startCoords$pointerI2;
      var pointerId = ev.pointerId;
      var startX = ((_startCoords$pointerI = startCoords[pointerId]) === null || _startCoords$pointerI === void 0 ? void 0 : _startCoords$pointerI.x) || ev.clientX;
      var startY = ((_startCoords$pointerI2 = startCoords[pointerId]) === null || _startCoords$pointerI2 === void 0 ? void 0 : _startCoords$pointerI2.y) || ev.clientY;
      var deltaX = ev.clientX - startX;
      var deltaY = ev.clientY - startY;

      // 스와이프 방향 감지
      var threshold = 1;
      var moveOffset = 4 * videoScale;
      var _maxMove2 = Math.round((videoScale - 1) / 2 * 100);
      if (videoScale > 1) {
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          if (deltaX > threshold) {
            console.log('Swipe Right');
            setVideoMoveX(function (x) {
              return Math.min(x + moveOffset, _maxMove2);
            });
            startCoordsRef.current[pointerId] = {
              x: ev.clientX,
              y: ev.clientY
            };
            // 스와이프 오른쪽 로직
          } else if (deltaX < -threshold) {
            console.log('Swipe Left');
            startCoordsRef.current[pointerId] = {
              x: ev.clientX,
              y: ev.clientY
            };
            setVideoMoveX(function (x) {
              return Math.max(x - moveOffset, -_maxMove2);
            });
            // 스와이프 왼쪽 로직
          }
        } else {
          if (deltaY > threshold / 2) {
            console.log('Swipe Down');
            startCoordsRef.current[pointerId] = {
              x: ev.clientX,
              y: ev.clientY
            };
            // 스와이프 아래쪽 로직
            setVideoMoveY(function (x) {
              return Math.min(x + moveOffset, _maxMove2);
            });
          } else if (deltaY < -threshold / 2) {
            console.log('Swipe Up');
            startCoordsRef.current[pointerId] = {
              x: ev.clientX,
              y: ev.clientY
            };
            setVideoMoveY(function (x) {
              return Math.max(x - moveOffset, -_maxMove2);
            });
            // 스와이프 위쪽 로직
          }
        }
      }
    }
  }, [videoScale]);
  var throttledPointermoveHandler = (0, _react.useMemo)(function () {
    return (0, _lodash.throttle)(pointermoveHandler, 100);
  }, [pointermoveHandler]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: videoRef,
    className: (0, _clsx11["default"])(classes.root, _defineProperty({}, classes.fullscreenRoot, fullscreen))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: fullScreenRef,
    className: (0, _clsx11["default"])(classes.videoDiv, (_clsx6 = {}, _defineProperty(_clsx6, classes.mapboxVideoDiv, mapboxModal), _defineProperty(_clsx6, classes.multiViewDiv, multiView), _defineProperty(_clsx6, classes.videoFullScreen, fullscreen), _defineProperty(_clsx6, classes.videoDivApp, app), _defineProperty(_clsx6, classes.videoDivAppLandscape, app && landscape), _clsx6))
    // // mantis- 11582, 비디오 영역에 마우스가 들어오면 다시 컨트롤 바 출력. (Leehj)
    // 11610 수정
    ,
    onMouseEnter: !app ? function () {
      setHideCtrl(false);
    } : undefined,
    onMouseMove: !app ? function () {
      setHideCtrl(false);
    } : undefined
    // 웹에서 FlipMenu 오픈시 컨트롤바 사라지는 이슈수정(Leehj)
    ,
    onMouseLeave: !app ? function () {
      !forceViewCtrl && setHideCtrl(true);
    } : undefined,
    onClick: app ? function () {
      setHideCtrl(false);
    } : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx11["default"])(classes.video, (_clsx7 = {}, _defineProperty(_clsx7, classes.videoHFlip, !vFlip && hFlip), _defineProperty(_clsx7, classes.videoVFlip, vFlip && !hFlip), _defineProperty(_clsx7, classes.videoFlip, vFlip && hFlip), _clsx7)),
    style: {
      transform: "translate(".concat(videoMoveX, "%, ").concat(videoMoveY, "%) scale(").concat(hFlip ? -videoScale : videoScale, ", ").concat(videoScale, ")"),
      transition: 'transform 0.1s linear'
    },
    onPointerDown: pointerdownHandler,
    onPointerMove: throttledPointermoveHandler,
    onPointerUp: pointerupHandler,
    onPointerCancel: pointerupHandler,
    onPointerOut: pointerupHandler,
    onPointerLeave: pointerupHandler
  }, /*#__PURE__*/_react["default"].createElement("video", {
    style: {
      width: ios17Browser && fullscreen ? '50%' : '100%',
      height: ios17Browser && fullscreen ? '50%' : '100%',
      transform: remoteTransform
    },
    ref: remoteView,
    className: "video-js"
    // playsInline
    ,
    "webkit-playsinline": "true",
    autoPlay: true,
    playsInline: true
    // controls
    ,
    muted: muted && volume === 0
    // muted
    ,
    onPlay: function onPlay() {
      //ios에서 이 코드 때문에 재생하지도 않았는데, 로딩창이 없어지는 문제로 주석처리
      // console.log("LiveViewPlayer", "set loading to false", "onPlay");
      // setLoading(false);
    },
    onError: function onError(e) {
      return console.log('video error', e);
    }
  }), /*#__PURE__*/_react["default"].createElement("video", {
    ref: localView,
    className: "video-js",
    autoPlay: true,
    "webkit-playsinline": "true",
    playsInline: true,
    controls: true,
    muted: true,
    style: {
      width: 0,
      height: 0
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0
    },
    ref: testView
  })), loading && !failToConnect && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.overlayDiv,
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    className: classes.circularLoading,
    size: 48,
    thickness: 5
  })), failToConnect && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.overlayDiv,
    style: {
      display: 'flex',
      justifyContent: 'center',
      gap: '2rem',
      alignItems: 'center',
      margin: '0 2rem'
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "54",
    height: "55",
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "27",
    cy: "27.5",
    r: "25.5",
    stroke: "#EEEEF3",
    strokeWidth: "3"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "25",
    y: "11.5",
    width: "4",
    height: "24",
    rx: "1",
    fill: "#EEEEF3"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "25",
    y: "39.5",
    width: "4",
    height: "4",
    rx: "1",
    fill: "#EEEEF3"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'start'
    }
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: mobile ? 'Body' : 'H2',
    style: {
      marginBottom: 8
    },
    htmlColor: _pittaModules.LightColors.primary['0']
  }, t('Oops!')), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: 'Body',
    htmlColor: _pittaModules.LightColors.primary['0'],
    dangerouslySetInnerHTML: {
      __html: t('Unable to establish_').replace(
      // eslint-disable-next-line no-control-regex
      new RegExp('\n', 'g'), '<br/>')
    }
  }))), retryConnect && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.overlayDiv,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    style: {
      marginBottom: 26,
      color: '#0095E0'
    }
  }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: 'Body',
    htmlColor: _pittaModules.LightColors.primary['0'],
    dangerouslySetInnerHTML: {
      __html: t('Connection has been_').replace(
      // eslint-disable-next-line no-control-regex
      new RegExp('\n', 'g'), '<br/>')
    }
  })), twoWayInUse && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx11["default"])(classes.twoWayAlert, _defineProperty({}, classes.twoWayAlertMulti, multiView || fullscreen))
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Alerts, {
    severity: "warning",
    mode: "web"
  }, t('Voice call in use'))), directionChangeFailed && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx11["default"])(classes.twoWayAlert, _defineProperty({}, classes.twoWayAlertMulti, multiView))
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Alerts, {
    severity: "warning",
    mode: "web"
  }, t('Direction change failed'))), refresh && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mobilePlayCtrlDiv
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mobilePlayCtrl
  }, renderCtrlIcon(/*#__PURE__*/_react["default"].createElement(_Refresh["default"], {
    style: {
      fontSize: '3rem'
    }
  }), startPlay))), true && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx11["default"])(classes.ctrlContDiv, _defineProperty({}, classes.ctrlContDivFullscreenApp, app && browserName === 'chromium-webview' && fullscreen))
  }, volumeCtrlMarkup), !main && !camera && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.addCameraDiv
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.addCameraBtn,
    onClick: function onClick() {
      return onAddCamera === null || onAddCamera === void 0 ? void 0 : onAddCamera();
    }
  }, /*#__PURE__*/_react["default"].createElement(_AddCircleOutline["default"], {
    style: {
      marginBottom: 8
    }
  }), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Typography, {
    category: "Default",
    variant: "Body"
  }, t('Add camera')))), mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MobileMenu, {
    open: openFlipMenu,
    onClose: function onClose() {
      return setOpenFlipMenu(false);
    },
    container: fullScreenRef.current,
    paperClasses: color === 'dark' ? classes.darkMobileMenu : ''
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
    className: (0, _clsx11["default"])(classes.mobileMemuItem),
    onClick: function onClick() {
      setOpenFlipMenu(false);
      setHFlip(function (f) {
        return !f;
      });
    }
  }, t('Flip horizontally'))), !mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Menu, {
    style: {
      zIndex: 2147483647
    },
    paperClasses: {
      root: classes.playerMenuDiv
    },
    open: openFlipMenu,
    anchorEl: flipAnchorRef.current,
    onClickAway: function onClickAway() {
      return setOpenFlipMenu(false);
    },
    placement: "top"
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.WebMenuItem, {
    className: (0, _clsx11["default"])(classes.webMenuDiv),
    onClick: function onClick() {
      setOpenFlipMenu(false);
      setHFlip(function (f) {
        return !f;
      });
    }
  }, t('Flip horizontally'))), mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.MobileMenu, {
    open: openMenu,
    container: fullScreenRef.current,
    onClose: function onClose() {
      return setOpenMenu(false);
    },
    paperClasses: color === 'dark' ? classes.darkMobileMenu : ''
  }, directionMenuMarkup), !mobile && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Menu, {
    style: {
      zIndex: 2147483647
    },
    open: openMenu,
    anchorEl: menuAnchorRef === null || menuAnchorRef === void 0 ? void 0 : menuAnchorRef.current,
    onClickAway: function onClickAway() {
      return setOpenMenu(false);
    },
    placement: "bottom-end",
    disablePortal: true,
    modifiers: {
      preventOverflow: {
        enabled: false
      },
      offset: {
        enabled: true,
        offset: '0px, 20px'
      },
      flip: {
        enabled: false
      }
    }
  }, directionMenuMarkup), fullscreen && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Toast, {
    open: openUnplugged,
    message: t('Camera is unplugged'),
    onClose: function onClose() {
      setTimeout(function () {
        return setOpenUnplugged(false);
      }, 6000);
    }
  })), /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
    open: liveModal,
    onClose: function onClose() {
      return setLiveModal(false);
    },
    onClickPositive: function onClickPositive() {
      //10604 - 퍼블릭 대시캠 연결 끊긴 경우 앱에서는 뒤로가기 메시지 전달하도록 수정 (mckim)
      if (app) {
        onFinishLiveview('DEVICE_DISCONNECT');
      } else {
        setLiveModal(false);
        history.push('/cameras');
      }
    },
    heading: "Camera disconnected from the Cloud.",
    content: '',
    RButton: "OK"
  }));
});
exports.LiveViewPlayer = LiveViewPlayer;